<template>
    <!-- 利益冲突申报 -->
    <div class="interest_container" id="interest_container">
        <div class="interest_body" v-if="isShow == 0">
            <div style="text-align:center;">
							<h4 style="width:calc(100% - 100px);display: inline-block;">{{$en('廉洁承诺书')}}</h4>
							<span style="font-size: 16px;color: #2d2dfd;font-weight: 700;" @click="changeLanguage(true)">{{isZh?'EN':'中文'}}</span>
						</div>
            <div class="interest_body_content">
                <span style="text-indent:2em;display: block;">{{$t('sbljcns1')}}</span>
								<span style="text-indent:2em;display: block;">{{$t('sbljcns2')}}</span>
            </div>

            <div class="interest_bottom_btn" @click="receiptEvent">{{$t('sbwjs')}}</div>
        </div>

        <div class="interest_show_content" v-if="isShow == 1">
					<div style="height:60px;text-align: right;" v-if="!isPC">
						<van-button @click="onSubmit(true)" plain style="top: 10px;right: 3%;height:40px;width:120px;background:rgb(230,240,255);color:#0283ef;">{{$en('暂存')}}</van-button>
					</div>
					<van-button v-if="isPC" @click="onSubmit(true)" plain class="pc_save_btn">{{$en('暂存')}}</van-button>
					<van-swipe :touchable="!curSelect" :show-indicators="false" :loop="false" @change="swipeChangeEvent" ref="swipe" style="height:calc(100% - 60px);">
					<!-- <van-swipe :style="curSelect?'pointer-events:none;':''" :show-indicators="false" :loop="false" @change="swipeChangeEvent" ref="swipe" style="height:calc(100% - 60px);"> -->
					<!-- <van-swipe :show-indicators="false" :loop="false" @change="swipeChangeEvent" ref="swipe" style="height:calc(100% - 60px);"> -->
							<van-swipe-item v-for="(item, index) in datas" :key="index" style="overflow-y: auto;">
									<div class="show_content_box">
											<div class="content_box_head">
													<div class="box_head_line"></div>
													<div class="box_head_title">{{ item.title }}</div>
													<div class="box_head_num"><span style="font-size:18px; font-weight: 700; color: #333;">{{ index+1 }}</span>/9</div>
											</div>

											<div class="content_box_middle" v-html="item.quest"></div>

											<div class="content_box_select">
													<div :class="[item.whether == '是' ? 'select_item_block' : 'select_default_block']" @click="selectItemEvent(index,'是')">
															<div :class="[item.whether == '是' ? 'check_select_block' : 'check_default_block']">
																	<i class="el-icon-check" v-if="item.whether == '是'" style="color: white;font-size: 14px;"></i>
															</div>
															<span class="box_select_text">{{$en('是')}}</span>
													</div>
													<div :class="[item.whether == '否' ? 'select_item_block' : 'select_default_block']" style="margin-top: 10px;" @click="selectItemEvent(index,'否')">
															<div :class="[item.whether == '否' ? 'check_select_block' : 'check_default_block']">
																	<i class="el-icon-check" v-if="item.whether == '否'" style="color: white;font-size: 14px;"></i>
															</div>
															<span class="box_select_text">{{$en('否')}}</span>
													</div>
											</div>

											<div class="content_box_areatext" v-if="item.whether == '是'">
													<div v-if="index==0">
														<div v-for="(person,personIndex) in item.persons" class="parent_card">
															<van-cell-group>
																<van-cell class="title_card" :title="`${$en('投资信息')}${item.persons&&item.persons.length>1?personIndex+1:''}`">
																	<van-icon  v-if="personIndex==0" name="plus" class="flex interest_van_icon" color="#4D9EFF" @click.stop="item.persons.push({type:'本人',companys:[{}]});$message.success($en('添加成功'));$forceUpdate();"/>
																	<van-icon v-else name="minus" class="flex interest_van_icon" color="#4D9EFF" @click.stop="item.persons.splice(personIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																</van-cell>
																<!-- <van-field autocomplete="off" required readonly is-link v-model="person.type" label="类型" placeholder="请选择类型" @click.native="showPicker(['本人','他人'],person.type,(val)=>{selectType(personIndex,val)})">
																</van-field> -->
																<div class="van-cell" style="padding-left:26px;">
																	<!-- <div class="van-cell__title van-cell--required">类型</div> -->
																	<van-radio-group v-model="person.type" direction="horizontal" checked-color="#38A65A" @change="(val)=>{selectType(personIndex,val)}">
																		<van-radio name="本人">{{$en('本人')}}</van-radio>
																		<van-radio name="他人名义">{{$en('他人名义')}}</van-radio>
																	</van-radio-group>
																</div>
																<van-field maxlength="100" autocomplete="off" required v-if="person.type=='他人名义'" v-model="person.personName" :placeholder="$en('请填写姓名')" :label="$en('姓名')" />
																<!-- <van-field maxlength="100" autocomplete="off" required v-if="person.type=='本人'" v-model="person.personNo" type="number" placeholder="请填写工号" label="工号" /> -->
																<van-field maxlength="100" autocomplete="off" required v-if="person.type=='他人名义'" v-model="person.personPhone" type="tel" :placeholder="$en('请填写手机号')" :label="$en('手机号')" />
																<!-- 企业信息 -->
																<section class="son_card" v-for="(company,companyIndex) in person.companys">
																	<van-cell class="title_card_son" :title="`${$en('企业信息')}${person.companys&&person.companys.length>1?companyIndex+1:''}`">
																		<van-icon  v-if="companyIndex==0" name="plus" class="flex interest_van_icon" color="#4D9EFF" @click.stop="person.companys.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																		<van-icon v-else name="minus" class="flex interest_van_icon" color="#4D9EFF" @click.stop="person.companys.splice(companyIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																	</van-cell>
																	<!-- <van-field maxlength="100" autocomplete="off" required v-model="company.companyName" placeholder="请填写企业名称" label="企业名称">
																		<template #button>
																			<van-icon v-if="companyIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="person.companys.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																			<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="person.companys.splice(companyIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																		</template>
																	</van-field>
																	<van-field maxlength="100" autocomplete="off" required v-model="company.companyId" placeholder="请填写统一社会信用代码" label="统一社会信用代码" label-width="130"/> -->
																	<CompanySelect v-model="company.companyId" :companyName.sync="company.companyName"/>
																	<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[company.mode]" :label="$en('投资模式')" :placeholder="$en('请选择投资模式')" @click.stop="showPicker(['独资','合资/合股','承包','租赁','其他'],company.mode,(val)=>{index0ModeSelect(val,personIndex,companyIndex)})"/>
																	<van-field maxlength="100" autocomplete="off" v-if="company.mode=='合资/合股'" v-model="company.ratio" type="number" :label="$en('占比')" :placeholder="$en('请填写占比')" @input="company.ratio=ratioInput($event)">
																		<template #button>
																			<span style="color:#333333;">%</span>
																		</template>
																	</van-field>
																	<van-field type="textarea" rows="1" autosize maxlength="500" autocomplete="off" required v-if="company.mode=='其他'" v-model="company.other" :label="$en('其他')" :placeholder="$en('请填写其他')" />
																</section>
															</van-cell-group>
														</div>
													</div>
													<div v-else-if="index==1">
														<div v-for="(company,companyIndex) in item.companys" :key="companyIndex" class="parent_card parent_card_pt20">
															<van-cell-group>
																<!-- <van-cell class="title_card" :title="`企业信息${item.companys&&item.companys.length>1?companyIndex+1:''}`">
																	<van-icon v-if="companyIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.companys.push({persons:[{}]});$message.success($en('添加成功'));$forceUpdate();"/>
																	<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.companys.splice(companyIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																</van-cell> -->
																<section class="son_card" v-for="(person,personIndex) in company.persons">
																	<van-cell class="title_card_son" :title="`${$en('关系人信息')}${index1MaxPersonIndex>0?(person.curPersonIndex?person.curPersonIndex:0)+1:''}`">
																		<van-icon v-if="personIndex==0" name="plus" class="flex interest_van_icon" color="#4D9EFF" @click.stop="index1AddPerson(companyIndex,personIndex)"/>
																		<van-icon v-if="companyIndex+personIndex>0" name="minus" class="flex interest_van_icon" color="#4D9EFF" @click.stop="index1DeletePerson(companyIndex,personIndex)"/>
																	</van-cell>
																	<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[person.relationship]" :label="$en('关系')" :placeholder="$en('请选择关系')" @click.native="showPicker(['配偶','子女','本人及配偶的父母'],person.relationship,(val)=>{person.relationship=val})"/>
																	<van-field maxlength="100" autocomplete="off" required v-model="person.name" :placeholder="$en('请填写姓名')" :label="$en('姓名')"/>
																	<!-- <van-field maxlength="100" autocomplete="off" required v-model="person.idCard" placeholder="请填写身份证号" label="身份证号"/> -->
																	<!-- <van-field maxlength="100" autocomplete="off" required readonly is-link v-model="person.investmentType" label="投资类型" placeholder="请选择投资类型" @click.native="showPicker(['独资','合资/合股'],person.investmentType,(val)=>{person.investmentType=val})" /> -->
																	<div class="van-cell">
																		<div class="van-cell__title van-cell--required">{{$en('投资类型')}}</div>
																		<van-radio-group v-model="person.investmentType" direction="horizontal" checked-color="#38A65A" @change="person.ratio?person.ratio='':''">
																			<van-radio name="独资">{{$en('独资')}}</van-radio>
																			<van-radio name="合资/合股">{{$en('合资/合股')}}</van-radio>
																		</van-radio-group>
																	</div>
																	<van-field maxlength="100" autocomplete="off" v-if="person.investmentType=='合资/合股'" v-model="person.ratio" type="number" :label="$en('占比')" :placeholder="$en('请填写占比')" @input="person.ratio=ratioInput($event)">
																		<template #button>
																			<span style="color:#333333;">%</span>
																		</template>
																	</van-field>
																</section>
																<CompanySelect v-model="company.companyId" :companyName.sync="company.companyName"/>
																<!-- <van-field maxlength="100" autocomplete="off" required v-model="company.companyName" placeholder="请填写企业名称" label="企业名称">
																</van-field>
																<van-field maxlength="100" autocomplete="off" required v-model="company.companyId" placeholder="请填写统一社会信用代码" label="统一社会信用代码" label-width="130"/> -->
																<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[company.companyRelationship]" :label="$en('与三一集团的关系')" :placeholder="$en('请选择与三一集团的关系')" @click.native="showPicker(['下属企业','竞争关系','无'],company.companyRelationship,(val)=>{company.companyRelationship=val})" label-width="130" />
															</van-cell-group>
														</div>
													</div>
													<div v-else-if="index==2">
														<div v-for="(company,companyIndex) in item.companys" class="parent_card parent_card_pt20">
															<van-cell-group>
																<!-- <van-cell class="title_card" :title="`企业信息${item.companys&&item.companys.length>1?companyIndex+1:''}`">
																	<van-icon v-if="companyIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.companys.push({persons:[{}]});$message.success($en('添加成功'));$forceUpdate();"/>
																	<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.companys.splice(companyIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																</van-cell> -->
																<!-- <van-field maxlength="100" autocomplete="off" required v-model="company.companyName" placeholder="请填写企业名称" label="企业名称">
																</van-field>
																<van-field maxlength="100" autocomplete="off" required v-model="company.companyId" placeholder="请填写统一社会信用代码" label="统一社会信用代码" label-width="130"/> -->
																<section class="son_card" v-for="(person,personIndex) in company.persons">
																	<van-cell class="title_card_son" :title="`${$en('关系人信息')}${index2MaxPersonIndex>0?(person.curPersonIndex?person.curPersonIndex:0)+1:''}`">
																		<van-icon v-if="personIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="index2AddPerson(companyIndex,personIndex)"/>
																		<van-icon v-if="companyIndex+personIndex>0" name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="index2DeletePerson(companyIndex,personIndex)"/>
																	</van-cell>
																	<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[person.relationship]" :label="$en('关系')" :placeholder="$en('请选择关系')" @click.native="showPicker(['配偶','子女','本人及配偶的父母'],person.relationship,(val)=>{person.relationship=val})" />
																	<van-field maxlength="100" autocomplete="off" required v-model="person.personName" :placeholder="$en('请填写姓名')" :label="$en('姓名')"/>
																	<van-field maxlength="100" autocomplete="off" required v-model="person.personPhone" type="tel" :placeholder="$en('请填写手机号')" :label="$en('手机号')" />
																	<van-field maxlength="100" autocomplete="off" required v-model="person.position" :placeholder="$en('请填写任职岗位')" :label="$en('任职岗位')" />
																</section>
																<CompanySelect v-model="company.companyId" :companyName.sync="company.companyName"/>
																<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[company.corporateRelations]" :label="$en('企业关系')" :placeholder="$en('请选择企业关系')" @click.native="showPicker(['供应商','客户','代理商','竞争方'],company.corporateRelations,(val)=>{company.corporateRelations=val})" />
															</van-cell-group>
														</div>
													</div>
													<div v-else-if="index==3">
														<div v-for="(person,personIndex) in item.persons" class="parent_card">
															<van-cell-group>
																<van-cell class="title_card" :title="`${$en('人员信息')}${item.persons&&item.persons.length>1?personIndex+1:''}`">
																	<van-icon v-if="personIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.persons.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																	<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.persons.splice(personIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																</van-cell>
																<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[person.relationship]" :label="$en('关系')" :placeholder="$en('请选择关系')" @click.native="showPicker(['配偶','子女','本人及配偶的父母'],person.relationship,(val)=>{person.relationship=val})" />
																<van-field maxlength="100" autocomplete="off" required v-model="person.personName" :placeholder="$en('请填写姓名')" :label="$en('姓名')">
																</van-field>
																<van-field maxlength="100" autocomplete="off" required v-model="person.personPhone" type="tel" :placeholder="$en('请填写手机号')" :label="$en('手机号')" />
																<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[person.communicationType]" :label="$en('往来类型')" :placeholder="$en('请选择往来类型')" @click.native="showPicker(['往来个人','往来公司'],person.communicationType,(val)=>{index3CommunicationTypeSelect(val,personIndex)})" />
																<van-field maxlength="100" v-show="person.communicationType=='往来个人'" autocomplete="off" required v-model="person.communicationPersonName" :placeholder="$en('请填写个人姓名')" :label="$en('个人姓名')" />
																<van-field maxlength="100" v-show="person.communicationType=='往来个人'" autocomplete="off" required v-model="person.communicationPersonPhone" :placeholder="$en('请填写联系电话')" :label="$en('联系电话')"/>
																<!-- <van-field maxlength="100" v-if="person.communicationType=='往来公司'" autocomplete="off" required v-model="person.communicationCompanyName" placeholder="请填写企业名称" label="企业名称" />
																<van-field maxlength="100" v-if="person.communicationType=='往来公司'" autocomplete="off" required v-model="person.communicationCompanyId" placeholder="请填写统一社会信用代码" label="统一社会信用代码" label-width="130"/> -->
																<CompanySelect v-model="person.companyId" :companyName.sync="person.companyName" v-show="person.communicationType=='往来公司'"/>
															</van-cell-group>
														</div>
													</div>
													<div v-else-if="index==4">
														<div v-for="(company,companyIndex) in item.companys" class="parent_card">
															<van-cell-group>
																<van-cell class="title_card" :title="`${$en('企业信息')}${item.companys&&item.companys.length>1?companyIndex+1:''}`">
																	<van-icon v-if="companyIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.companys.push({persons:[{}]});$message.success($en('添加成功'));$forceUpdate();"/>
																	<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.companys.splice(companyIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																</van-cell>
																<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[company.companyType]" :label="$en('任职单位类型')" :placeholder="$en('请填写任职单位类型')" @click.native="showPicker(['内部','供应商','代理商','其他'],company.companyType,(val)=>{companyType4Select(val,companyIndex)})">
																</van-field>
																<!-- <van-field maxlength="100" v-if="company.companyType=='内部'" autocomplete="off" required v-model="company.companyName" placeholder="请选择部门" label="任职部门"/> -->
																<CompanySelect v-show="company.companyType" v-model="company.companyId" :companyName.sync="company.companyName" :companyType="company.companyType=='内部'?1:2"/>
																<!-- <van-field maxlength="100" v-else-if="company.companyType" autocomplete="off" required v-model="company.companyName" placeholder="请填写企业名称" label="任职企业名称"/>
																<van-field maxlength="100" v-else-if="company.companyType" autocomplete="off" required v-model="company.companyId" placeholder="请填写统一社会信用代码" label="统一社会信用代码" label-width="130"/> -->
																<section class="son_card" v-for="(person,personIndex) in company.persons">
																	<van-cell class="title_card_son" :title="`${$en('关系人信息')}${company.persons&&company.persons.length>1?personIndex+1:''}`">
																		<van-icon v-if="personIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="company.persons.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																		<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="company.persons.splice(personIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																	</van-cell>
																	<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[person.relationship]" :label="$en('关系')" :placeholder="$en('请选择关系')" @click.native="showPicker(['亲属','同学','朋友'],person.relationship,(val)=>{person.relationship=val})" />
																	<PersonSelect v-if="company.companyType=='内部'"
																	v-model="person.personNo" :personName.sync="person.personName" @select="index4PersonSelect($event,companyIndex,personIndex)"/>
																	<van-field maxlength="100" v-if="company.companyType!='内部'" autocomplete="off" required v-model="person.personName" :placeholder="$en('请填写姓名')" :label="$en('姓名')">
																		<!-- <template #button>
																			<van-icon v-if="personIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="company.persons.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																			<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="company.persons.splice(personIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																		</template> -->
																	</van-field>
																	<van-field maxlength="100" v-if="company.companyType!='内部'" autocomplete="off" required v-model="person.personPhone" type="tel" :placeholder="$en('请填写手机号')" :label="$en('手机号')" />
																	<van-field maxlength="100" v-if="company.companyType!='内部'" autocomplete="off" required v-model="person.position" :placeholder="$en('请填写任职岗位')" :label="$en('任职岗位')" />
																</section>
															</van-cell-group>
														</div>
													</div>
													<div v-else-if="index==5">
														<div v-for="(person,personIndex) in item.persons" class="parent_card">
															<van-cell-group>
																<van-cell class="title_card" :title="`${$en('职工信息')}${item.persons&&item.persons.length>1?personIndex+1:''}`">
																		<van-icon v-if="personIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.persons.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																		<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.persons.splice(personIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																</van-cell>
																<section class="son_card">
																	<van-field maxlength="100" label-width="50px" autocomplete="off" required readonly is-link v-model="$ens[person.relationship]" :label="$en('关系')" :placeholder="$en('请选择关系')" @click.native="showPicker(['配偶','本人父母','配偶父母','子女','子女配偶及其父母','祖（外）父母','（外）孙子女','（外）孙子女配偶及其父母','继父母','继子女','继子女配偶及其父母','亲兄弟姐妹（及其配偶）','伯叔（母）','姑母（父）','堂兄弟姐妹（及其配偶）','舅父（母）','姨母（父）','表兄弟姐妹（及其配偶）','侄子女（及其配偶）','甥子女（及其配偶）','其他亲友'],person.relationship,(val)=>{person.relationship=val})">
																	</van-field>
																	<PersonSelect allPerson v-model="person.personNo" :personName.sync="person.personName" @select="index5PersonSelect($event,personIndex)"/>
																	<!-- <van-field maxlength="100" autocomplete="off" required v-model="person.personName" :placeholder="$en('请填写姓名').toLowerCase()})" :label="$en('姓名')">
																		<template #button>
																			<van-icon v-if="personIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="company.persons.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																			<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="company.persons.splice(personIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																		</template>
																	</van-field> -->
																</section>
															</van-cell-group>
														</div>
													</div>
													<div v-else-if="index==7">
														<div v-for="(person,personIndex) in item.persons" class="parent_card">
															<van-cell-group>
																<van-cell class="title_card" :title="`${$en('人员信息')}${item.persons&&item.persons.length>1?personIndex+1:''}`">
																	<van-icon v-if="personIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.persons.push({businesss:[{}]});$message.success($en('添加成功'));$forceUpdate();"/>
																	<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.persons.splice(personIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																</van-cell>
																<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[person.relationship]" :label="$en('关系')" :placeholder="$en('请选择关系')" @click.native="showPicker(['本人','亲友','同学','老乡'],person.relationship,(val)=>{relationshipSelect7(val,personIndex)})">
																</van-field>
																<van-field maxlength="100" autocomplete="off" v-if="person.relationship!='本人'" required v-model="person.personName" :placeholder="$en('请填写姓名')" :label="$en('姓名')" />
																<van-field maxlength="100" autocomplete="off" v-if="person.relationship!='本人'" required v-model="person.personPhone" type="tel" :placeholder="$en('请填写手机号')" :label="$en('手机号')" />
																<section class="son_card" v-for="(business,businessIndex) in person.businesss">
																	<van-cell class="title_card_son" :title="`${$en('关系人信息')}${person.businesss&&person.businesss.length>1?businessIndex+1:''}`">
																		<van-icon v-if="businessIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="person.businesss.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																		<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="person.businesss.splice(businessIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																	</van-cell>
																	<CompanySelect v-model="business.companyId" :companyName.sync="business.companyName"/>
																	<!-- <van-field maxlength="100" autocomplete="off" required v-model="business.companyName" placeholder="请填写供应商全称" label="供应商全称" />
																	<van-field maxlength="100" autocomplete="off" required v-model="business.companyId" placeholder="请填写统一社会信用代码" label="统一社会信用代码" label-width="130"/> -->
																	<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[business.businessType]" :label="$en('业务类型')" :placeholder="$en('请选择业务类型')" @click.native="showPicker(['基建施工','采购','外协','零部件加工','供应商相关','其他'],business.businessType,(val)=>{business.businessType=val})">
																		<!-- <template #button>
																			<van-icon v-if="businessIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="person.businesss.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																			<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="person.businesss.splice(businessIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																		</template> -->
																	</van-field>
																	<van-field maxlength="500" autocomplete="off" required v-model="business.position" :placeholder="$en('请填写业务描述')" :label="$en('业务描述')" rows="1" autosize type="textarea" label-width="90px"/>
																</section>
															</van-cell-group>
														</div>
													</div>
													<div v-else-if="index==8">
														<div v-for="(person,personIndex) in item.persons" class="parent_card">
															<van-cell-group>
																<van-cell class="title_card" :title="`${$en('人员信息')}${item.persons&&item.persons.length>1?personIndex+1:''}`">
																	<van-icon v-if="personIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.persons.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																	<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.persons.splice(personIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																</van-cell>
																<!-- <van-field maxlength="100" autocomplete="off" required v-model="person.personName" placeholder="请填写干系人" :label="$en('关系人')">
																</van-field> -->
																<PersonSelect :label="$en('关系人')" v-model="person.personNo" :personName.sync="person.personName" @select="index8PersonSelect($event,personIndex)"/>
																<van-field maxlength="500" autocomplete="off" required v-model="person.itemDesc" :placeholder="$en('请填写事项描述')" :label="$en('事项描述')" rows="1" autosize type="textarea" label-width="90px"/>
															</van-cell-group>
														</div>
													</div>
													<span class="box_area_title">{{$en('备注')}}</span>
													<el-input type="textarea" v-model="item.describe" :placeholder="$en('请填写申报事项描述')" :autosize="{minRows:4}" maxlength="500" show-word-limit style="margin-top: 10px; font-size: 14px;"></el-input>
													
											</div>
											
											<div style="margin:20px;height:64px;">
												<div class="change_btn left_change_btn" v-if="currentPage != 0" @click="pageMuteEvent">
														<i class="change_tbn_i el-icon-arrow-left" style="font-size: 30px; color: white;"></i>
												</div>
												<div class="change_btn right_change_btn" v-if="currentPage != 8" @click="pageAddEvent">
														<i class="change_tbn_i el-icon-arrow-right" style="font-size: 30px; color: white;"></i>
												</div>
											</div>
									</div>
									<van-button type="info" v-if="index == 8" @click="nextStepEvent" style="background:#0169ff;margin-bottom:20px;margin-top:20px;height:40px;width:120px;">{{$en('下一步')}}</van-button>
							</van-swipe-item>
					</van-swipe>
					<!-- <van-button v-if="currentPage!=8" @click="onSubmit(true)" style="position: fixed;bottom:60px;left:50%;transform:translate(-50%,0);height:40px;width:120px;background:rgb(1, 105, 255);color:white;">暂存</van-button>
					<div class="change_btn_flex left_change_btn" v-if="currentPage != 0" @click="pageMuteEvent">
							<i class="el-icon-arrow-left" style="font-size: 30px; color: white;"></i>
					</div>

					<div class="change_btn_flex right_change_btn" v-if="currentPage != 8" @click="pageAddEvent">
							<i class="el-icon-arrow-right" style="font-size: 30px; color: white;"></i>
					</div> -->

            
        </div>

        <div class="interest_show_list" v-if="isShow == 2">
            <div class="show_list_block">
                <div class="show_list_item" v-for="(item, index) in datas" :key="index">
                    <div class="list_item_head">
                        <div class="item_head_line"></div>
                        <span class="item_head_title">{{ item.title }}</span>
                    </div>
                    <div class="list_item_quest" v-html="item.quest"></div>
                    <div class="list_item_check">
                        <div class="check_select_block">
                            <i class="el-icon-check" style="color: white;font-size: 14px;"></i>
                        </div>
                        <span class="box_select_text" v-if="item.whether == '是'">{{$en('是')}}</span>
                        <span class="box_select_text" v-if="item.whether == '否'">{{$en('否')}}</span>
                    </div>
										<van-form readonly class="last_page_list" v-if="item.whether == '是'">
											<div v-if="index==0">
												<div v-for="(person,personIndex) in item.persons" class="parent_card">
													<van-cell-group>
														<van-cell class="title_card" :title="`${$en('投资信息')}${item.persons&&item.persons.length>1?personIndex+1:''}`" @click.native="person.show=!person.show;$forceUpdate()">
															<span class="last_page_count">{{person.companys.length}} {{$en('个企业')}}</span>
															<van-icon v-if="person.show" name="arrow-up" class="flex interest_van_icon"/>
															<van-icon v-else name="arrow-down" class="flex interest_van_icon"/>
														</van-cell>
														<template v-if="person.show">
															<!-- <van-field autocomplete="off" required readonly is-link v-model="person.type" label="类型" placeholder="请选择类型" @click.native="showPicker(['本人','他人'],person.type,(val)=>{selectType(personIndex,val)})">
															</van-field> -->
															<div class="van-cell" style="padding-left:26px;">
																<!-- <div class="van-cell__title van-cell--required">类型</div> -->
																<van-radio-group v-model="person.type" direction="horizontal" disabled checked-color="#38A65A" @change="(val)=>{selectType(personIndex,val)}">
																	<van-radio name="本人">{{$en('本人')}}</van-radio>
																	<van-radio name="他人名义">{{$en('他人名义')}}</van-radio>
																</van-radio-group>
															</div>
															<van-field maxlength="100" autocomplete="off" required v-if="person.type=='他人名义'" v-model="person.personName" :placeholder="$en('请填写姓名')" :label="$en('姓名')" />
															<!-- <van-field maxlength="100" autocomplete="off" required v-if="person.type=='本人'" v-model="person.personNo" type="number" placeholder="请填写工号" label="工号" /> -->
															<van-field maxlength="100" autocomplete="off" required v-if="person.type=='他人名义'" v-model="person.personPhone" type="tel" :placeholder="$en('请填写手机号')" :label="$en('手机号')" />
															<!-- 企业信息 -->
															<section class="son_card" v-for="(company,companyIndex) in person.companys">
																<van-cell class="title_card_son" :title="`${$en('企业信息')}${person.companys&&person.companys.length>1?companyIndex+1:''}`">
																	<!-- <van-icon  v-if="companyIndex==0" name="plus" class="flex interest_van_icon" color="#4D9EFF" @click.stop="person.companys.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																	<van-icon v-else name="minus" class="flex interest_van_icon" color="#4D9EFF" @click.stop="person.companys.splice(companyIndex,1);$message.success($en('删除成功'));$forceUpdate();"/> -->
																</van-cell>
																<!-- <van-field maxlength="100" autocomplete="off" required v-model="company.companyName" placeholder="请填写企业名称" label="企业名称">
																	<template #button>
																		<van-icon v-if="companyIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="person.companys.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																		<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="person.companys.splice(companyIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																	</template>
																</van-field>
																<van-field maxlength="100" autocomplete="off" required v-model="company.companyId" placeholder="请填写统一社会信用代码" label="统一社会信用代码" label-width="130"/> -->
																<CompanySelect v-model="company.companyId" :companyName.sync="company.companyName"/>
																<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[company.mode]" :label="$en('投资模式')" placeholder="请选择投资模式"/>
																<van-field maxlength="100" autocomplete="off" v-if="company.mode=='合资/合股'" v-model="company.ratio" type="number" :label="$en('占比')" :placeholder="$en('请填写占比')" @input="company.ratio=ratioInput($event)">
																	<template #button>
																		<span style="color:#333333;">%</span>
																	</template>
																</van-field>
																<van-field type="textarea" rows="1" autosize maxlength="500" autocomplete="off" required v-if="company.mode=='其他'" v-model="company.other" label="其他" placeholder="请填写描述" />
															</section>
														</template>
													</van-cell-group>
												</div>
											</div>
											<div v-else-if="index==1">
												<div v-for="(company,companyIndex) in item.companys" :key="companyIndex" class="parent_card parent_card_pt20">
													<van-cell-group>
														<!-- <van-cell class="title_card" :title="`企业信息${item.companys&&item.companys.length>1?companyIndex+1:''}`">
															<van-icon v-if="companyIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.companys.push({persons:[{}]});$message.success($en('添加成功'));$forceUpdate();"/>
															<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.companys.splice(companyIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
														</van-cell> -->
														<section class="son_card" v-for="(person,personIndex) in company.persons">
															<van-cell class="title_card_son" :title="`${$en('关系人信息')}${index1MaxPersonIndex>0?(person.curPersonIndex?person.curPersonIndex:0)+1:''}`" @click.native="person.show=!person.show;$forceUpdate()">
																<!-- <van-icon v-if="personIndex==0" name="plus" class="flex interest_van_icon" color="#4D9EFF" @click.stop="index1AddPerson(companyIndex,personIndex)"/>
																<van-icon v-if="companyIndex+personIndex>0" name="minus" class="flex interest_van_icon" color="#4D9EFF" @click.stop="index1DeletePerson(companyIndex,personIndex)"/> -->
																<van-icon v-if="person.show" name="arrow-up" class="flex interest_van_icon"/>
																<van-icon v-else name="arrow-down" class="flex interest_van_icon"/>
															</van-cell>
															<template v-if="person.show">
																<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[person.relationship]" :label="$en('关系')" :placeholder="$en('请选择关系')"/>
																<van-field maxlength="100" autocomplete="off" required v-model="person.name" :placeholder="$en('请填写姓名')" :label="$en('姓名')"/>
																<!-- <van-field maxlength="100" autocomplete="off" required v-model="person.idCard" placeholder="请填写身份证号" label="身份证号"/> -->
																<!-- <van-field maxlength="100" autocomplete="off" required readonly is-link v-model="person.investmentType" label="投资类型" placeholder="请选择投资类型" @click.native="showPicker(['独资','合资/合股'],person.investmentType,(val)=>{person.investmentType=val})" /> -->
																<div class="van-cell">
																	<div class="van-cell__title van-cell--required">{{$en('投资类型')}}</div>
																	<van-radio-group v-model="person.investmentType" disabled direction="horizontal" checked-color="#38A65A" @change="person.ratio?person.ratio='':''">
																		<van-radio name="独资">{{$en('独资')}}</van-radio>
																		<van-radio name="合资/合股">{{$en('合资/合股')}}</van-radio>
																	</van-radio-group>
																</div>
																<van-field maxlength="100" autocomplete="off" v-if="person.investmentType=='合资/合股'" v-model="person.ratio" type="number" :label="$en('占比')" :placeholder="$en('请填写占比')" @input="person.ratio=ratioInput($event)">
																	<template #button>
																		<span style="color:#333333;">%</span>
																	</template>
																</van-field>
															</template>
														</section>
														<template v-if="company.persons.findIndex((itm)=>{return itm.show})>-1">
															<CompanySelect v-model="company.companyId" :companyName.sync="company.companyName"/>
															<!-- <van-field maxlength="100" autocomplete="off" required v-model="company.companyName" placeholder="请填写企业名称" label="企业名称">
															</van-field>
															<van-field maxlength="100" autocomplete="off" required v-model="company.companyId" placeholder="请填写统一社会信用代码" label="统一社会信用代码" label-width="130"/> -->
															<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[company.companyRelationship]" :label="$en('与三一集团的关系')" @click.native="showPicker(['下属企业','竞争关系','无'],company.companyRelationship,(val)=>{company.companyRelationship=val})" label-width="130" />
														</template>
													</van-cell-group>
												</div>
											</div>
											<div v-else-if="index==2">
												<div v-for="(company,companyIndex) in item.companys" class="parent_card parent_card_pt20">
													<van-cell-group>
														<!-- <van-cell class="title_card" :title="`企业信息${item.companys&&item.companys.length>1?companyIndex+1:''}`">
															<van-icon v-if="companyIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.companys.push({persons:[{}]});$message.success($en('添加成功'));$forceUpdate();"/>
															<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.companys.splice(companyIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
														</van-cell> -->
														<!-- <van-field maxlength="100" autocomplete="off" required v-model="company.companyName" placeholder="请填写企业名称" label="企业名称">
														</van-field>
														<van-field maxlength="100" autocomplete="off" required v-model="company.companyId" placeholder="请填写统一社会信用代码" label="统一社会信用代码" label-width="130"/> -->
														<section class="son_card" v-for="(person,personIndex) in company.persons">
															<van-cell class="title_card_son" :title="`${$en('关系人信息')}${index2MaxPersonIndex>0?(person.curPersonIndex?person.curPersonIndex:0)+1:''}`" @click.native="person.show=!person.show;$forceUpdate()">
																<van-icon v-if="person.show" name="arrow-up" class="flex interest_van_icon"/>
																<van-icon v-else name="arrow-down" class="flex interest_van_icon"/>	
															</van-cell>
															<template v-if="person.show"> 
																<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[person.relationship]" :label="$en('关系')" :placeholder="$en('请选择关系')"/>
																<van-field maxlength="100" autocomplete="off" required v-model="person.personName" :placeholder="$en('请填写姓名')" :label="$en('姓名')"/>
																<van-field maxlength="100" autocomplete="off" required v-model="person.personPhone" type="tel" :placeholder="$en('请填写手机号')" :label="$en('手机号')" />
																<van-field maxlength="100" autocomplete="off" required v-model="person.position" :placeholder="$en('请填写任职岗位')" :label="$en('任职岗位')" />
															</template>
														</section>
														<template v-if="company.persons.findIndex((itm)=>{return itm.show})>-1">
															<CompanySelect v-model="company.companyId" :companyName.sync="company.companyName"/>
															<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[company.corporateRelations]" :label="$en('企业关系')" :placeholder="$en('请选择企业关系')"/>
														</template>
													</van-cell-group>
												</div>
											</div>
											<div v-else-if="index==3">
												<div v-for="(person,personIndex) in item.persons" class="parent_card">
													<van-cell-group>
														<van-cell class="title_card" :title="`${$en('人员信息')}${item.persons&&item.persons.length>1?personIndex+1:''}`" @click.native="person.show=!person.show;$forceUpdate()">
															<!-- <van-icon v-if="personIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.persons.push({});$message.success($en('添加成功'));$forceUpdate();"/>
															<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.persons.splice(personIndex,1);$message.success($en('删除成功'));$forceUpdate();"/> -->
															<van-icon v-if="person.show" name="arrow-up" class="flex interest_van_icon"/>
															<van-icon v-else name="arrow-down" class="flex interest_van_icon"/>	
														</van-cell>
														<template v-if="person.show">
															<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[person.relationship]" :label="$en('关系')" :placeholder="$en('请选择关系')"/>
															<van-field maxlength="100" autocomplete="off" required v-model="person.personName" :placeholder="$en('请填写姓名')" :label="$en('姓名')">
															</van-field>
															<van-field maxlength="100" autocomplete="off" required v-model="person.personPhone" type="tel" :placeholder="$en('请填写手机号')" :label="$en('手机号')" />
															<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[person.communicationType]" :label="$en('往来类型')"/>
															<van-field maxlength="100" v-show="person.communicationType=='往来个人'" autocomplete="off" required v-model="person.communicationPersonName" :placeholder="$en('请填写个人姓名')" :label="$en('个人姓名')" />
															<van-field maxlength="100" v-show="person.communicationType=='往来个人'" autocomplete="off" required v-model="person.communicationPersonPhone" :placeholder="$en('请填写联系电话')" :label="$en('联系电话')"/>
															<!-- <van-field maxlength="100" v-if="person.communicationType=='往来公司'" autocomplete="off" required v-model="person.communicationCompanyName" placeholder="请填写企业名称" label="企业名称" />
															<van-field maxlength="100" v-if="person.communicationType=='往来公司'" autocomplete="off" required v-model="person.communicationCompanyId" placeholder="请填写统一社会信用代码" label="统一社会信用代码" label-width="130"/> -->
															<CompanySelect v-model="person.companyId" :companyName.sync="person.companyName" v-show="person.communicationType=='往来公司'"/>
														</template>
													</van-cell-group>
												</div>
											</div>
											<div v-else-if="index==4">
												<div v-for="(company,companyIndex) in item.companys" class="parent_card">
													<van-cell-group>
														<van-cell class="title_card" :title="`${$en('企业信息')}${item.companys&&item.companys.length>1?companyIndex+1:''}`" @click.native="company.show=!company.show;$forceUpdate()">
															<span class="last_page_count">{{company.persons.length}}{{$en('个关系人')}}</span>
															<van-icon v-if="company.show" name="arrow-up" class="flex interest_van_icon"/>
															<van-icon v-else name="arrow-down" class="flex interest_van_icon"/>
														</van-cell>
														<template v-if="company.show">
															<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[company.companyType]" :label="$en('任职单位类型')" :placeholder="$en('请填写任职单位类型')">
															</van-field>
															<!-- <van-field maxlength="100" v-if="company.companyType=='内部'" autocomplete="off" required v-model="company.companyName" placeholder="请选择部门" label="任职部门"/> -->
															<CompanySelect v-model="company.companyId" :companyName.sync="company.companyName" :companyType="company.companyType=='内部'?1:2"/>
															<!-- <van-field maxlength="100" v-else-if="company.companyType" autocomplete="off" required v-model="company.companyName" placeholder="请填写企业名称" label="任职企业名称"/>
															<van-field maxlength="100" v-else-if="company.companyType" autocomplete="off" required v-model="company.companyId" placeholder="请填写统一社会信用代码" label="统一社会信用代码" label-width="130"/> -->
															<section class="son_card" v-for="(person,personIndex) in company.persons">
																<van-cell class="title_card_son" :title="`${$en('关系人信息')}${company.persons&&company.persons.length>1?personIndex+1:''}`">
																	<!-- <van-icon v-if="personIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="company.persons.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																	<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="company.persons.splice(personIndex,1);$message.success($en('删除成功'));$forceUpdate();"/> -->
																</van-cell>
																<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[person.relationship]" :label="$en('关系')" :placeholder="$en('请选择关系')"/>
																<PersonSelect v-if="company.companyType=='内部'"
																v-model="person.personNo" :personName.sync="person.personName" @select="index4PersonSelect($event,companyIndex,personIndex)"/>
																<van-field maxlength="100" v-if="company.companyType!='内部'" autocomplete="off" required v-model="person.personName" :placeholder="$en('请填写姓名')" :label="$en('姓名')">
																	<!-- <template #button>
																		<van-icon v-if="personIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="company.persons.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																		<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="company.persons.splice(personIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																	</template> -->
																</van-field>
																<van-field maxlength="100" v-if="company.companyType!='内部'" autocomplete="off" required v-model="person.personPhone" type="tel" :placeholder="$en('请填写手机号')" :label="$en('手机号')" />
																<van-field maxlength="100" v-if="company.companyType!='内部'" autocomplete="off" required v-model="person.position" :placeholder="$en('请填写联系电话')" :label="$en('任职岗位')" />
															</section>
														</template>
													</van-cell-group>
												</div>
											</div>
											<div v-else-if="index==5">
												<div v-for="(person,personIndex) in item.persons" class="parent_card">
													<van-cell-group>
														<van-cell class="title_card" :title="`${$en('职工信息')}${item.persons&&item.persons.length>1?personIndex+1:''}`">
														</van-cell>
														<section class="son_card">
															<van-field maxlength="100" label-width="50px" autocomplete="off" required readonly is-link v-model="$ens[person.relationship]" :label="$en('关系')" :placeholder="$en('请选择关系')">
															</van-field>
															<PersonSelect allPerson v-model="person.personNo" :personName.sync="person.personName" @select="index5PersonSelect($event,personIndex)"/>
															<!-- <van-field maxlength="100" autocomplete="off" required v-model="person.personName" :placeholder="$en('请填写姓名').toLowerCase()})" :label="$en('姓名')">
																<template #button>
																	<van-icon v-if="personIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="company.persons.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																	<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="company.persons.splice(personIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																</template>
															</van-field> -->
														</section>
													</van-cell-group>
												</div>
											</div>
											<div v-else-if="index==7">
												<div v-for="(person,personIndex) in item.persons" class="parent_card">
													<van-cell-group>
														<van-cell class="title_card" :title="`${$en('人员信息')}${item.persons&&item.persons.length>1?personIndex+1:''}`" @click.native="person.show=!person.show;$forceUpdate()">
															<span class="last_page_count">{{person.businesss.length}}{{$en('个关系人')}}</span>
															<van-icon v-if="person.show" name="arrow-up" class="flex interest_van_icon"/>
															<van-icon v-else name="arrow-down" class="flex interest_van_icon"/>
															<!-- <van-icon v-if="personIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.persons.push({businesss:[{}]});$message.success($en('添加成功'));$forceUpdate();"/>
															<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.persons.splice(personIndex,1);$message.success($en('删除成功'));$forceUpdate();"/> -->
														</van-cell>
														<template v-if="person.show">
															<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[person.relationship]" :label="$en('关系')" :placeholder="$en('请选择关系')">
															</van-field>
															<van-field maxlength="100" autocomplete="off" v-if="person.relationship!='本人'" required v-model="person.personName" :placeholder="$en('请填写姓名')" :label="$en('姓名')" />
															<van-field maxlength="100" autocomplete="off" v-if="person.relationship!='本人'" required v-model="person.personPhone" type="tel" :placeholder="$en('请填写手机号')" :label="$en('手机号')" />
															<section class="son_card" v-for="(business,businessIndex) in person.businesss">
																<van-cell class="title_card_son" :title="`${$en('关系人信息')}${person.businesss&&person.businesss.length>1?businessIndex+1:''}`">
																	<!-- <van-icon v-if="businessIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="person.businesss.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																	<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="person.businesss.splice(businessIndex,1);$message.success($en('删除成功'));$forceUpdate();"/> -->
																</van-cell>
																<CompanySelect v-model="business.companyId" :companyName.sync="business.companyName"/>
																<!-- <van-field maxlength="100" autocomplete="off" required v-model="business.companyName" placeholder="请填写供应商全称" label="供应商全称" />
																<van-field maxlength="100" autocomplete="off" required v-model="business.companyId" placeholder="请填写统一社会信用代码" label="统一社会信用代码" label-width="130"/> -->
																<van-field maxlength="100" autocomplete="off" required readonly is-link v-model="$ens[business.businessType]" :label="$en('业务类型')" :placeholder="$en('请选择业务类型')">
																	<!-- <template #button>
																		<van-icon v-if="businessIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="person.businesss.push({});$message.success($en('添加成功'));$forceUpdate();"/>
																		<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="person.businesss.splice(businessIndex,1);$message.success($en('删除成功'));$forceUpdate();"/>
																	</template> -->
																</van-field>
																<van-field maxlength="500" autocomplete="off" required v-model="business.position" :placeholder="$en('请填写业务描述')" :label="$en('业务描述')" rows="1" autosize type="textarea" label-width="90px"/>
															</section>
														</template>
													</van-cell-group>
												</div>
											</div>
											<div v-else-if="index==8">
												<div v-for="(person,personIndex) in item.persons" class="parent_card">
													<van-cell-group>
														<van-cell class="title_card" :title="`${$en('人员信息')}${item.persons&&item.persons.length>1?personIndex+1:''}`" @click.native="person.show=!person.show;$forceUpdate()">
															<!-- <van-icon v-if="personIndex==0" name="plus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.persons.push({});$message.success($en('添加成功'));$forceUpdate();"/>
															<van-icon v-else name="minus" class="interest_van_icon" color="#4D9EFF" @click.stop="item.persons.splice(personIndex,1);$message.success($en('删除成功'));$forceUpdate();"/> -->
															<!-- <span class="last_page_count">{{person.businesss.length}}个关系人</span> -->
															<van-icon v-if="person.show" name="arrow-up" class="flex interest_van_icon"/>
															<van-icon v-else name="arrow-down" class="flex interest_van_icon"/>
														</van-cell>
														<!-- <van-field maxlength="100" autocomplete="off" required v-model="person.personName" placeholder="请填写干系人" :label="$en('关系人')">
														</van-field> -->
														<template v-if="person.show">
															<PersonSelect :label="$en('关系人')" v-model="person.personNo" :personName.sync="person.personName" @select="index8PersonSelect($event,personIndex)"/>
															<van-field maxlength="500" autocomplete="off" required v-model="person.itemDesc" :placeholder="$en('请填写事项描述')" :label="$en('事项描述')" rows="1" autosize type="textarea" label-width="90px"/>
														</template>
													</van-cell-group>
												</div>
											</div>
										</van-form>
                    <div class="list_item_desc" v-if="item.whether == '是'&&item.describe"><span style="font-weight: 700;">{{$en('申报描述：')}}</span>{{ item.describe }}</div>
                </div>

                <FieldUpload :fileIds="fileList" :label="$en('附件')" @fileChange="fileList=$event"/>

                <div class="show_list_check">
                    <van-checkbox v-model="checked" :disabled="disStatus" shape="square">{{$en('本人承诺已就相关利益冲突事项进行了以上如实申报，愿意接受公司的监督，如有不实之处，愿意接受公司的制度处理。')}}</van-checkbox>
										<br/><div class="show_list_check_text">{{$en('若申报后相关情况发生重大变化，应在30个工作日内补充申报')}}</div>
                </div>
            </div>
            <div class="show_list_bottom">
                <div class="list_bottom_btn" v-if="!disStatus" @click="proidStepEvent">{{$en('上一步')}}</div>
                <!-- <div class="list_limit_btn" v-if="disStatus">上一步</div> -->
                <div class="list_bottom_btn" v-if="checked" @click="onSubmit(false)">{{$en('提交')}}</div>
                <div class="list_limit_btn" v-if="!checked">{{$en('提交')}}</div>
								
            </div>
        </div>
				<van-popup v-model="pickerShow" position="bottom" class="picker_popup_mobile">
					<van-picker :columns="pickerColumns" :default-index="pickerDefIndex" show-toolbar @cancel="pickerShow=false" @confirm="pickerConfirm"/>
				</van-popup>
				<el-dialog :title="$en('请选择')" :visible.sync="pcPickerShow" width="400px" append-to-body :close-on-click-modal="false" custom-class="pc_picker_dialog" @close="pcPickerShow=false">
					<div class="pc_picker_list">
						<div v-for="(col,idx) in pickerColumns" :key="idx" :class="['pc_picker_item', pickerDefIndex===idx?'pc_picker_item_active':'']" @click="pcPickerSelect(idx,col)">
							{{typeof col=='object'?col.text:col}}
						</div>
					</div>
				</el-dialog>
    </div>
</template>
<script>
import CompanySelect from '@/plugins/CompanySelect'
import PersonSelect from '@/plugins/PersonSelect'
import { Toast } from 'vant-green'
export default {
  components: { CompanySelect , PersonSelect },
    data(){
        return{
						enLabelss:new Set(),
            isShow:0,
            currentPage:0,
            checked:false,
            disStatus:false,
						fileList:[],
						pickerShow:false,
						pickerDefIndex:0,
						pickerColumns:[],
						pickerCall:function(){},
						pcPickerShow:false,
						isPC: window.innerWidth >= 769,
						// 从0开始
						index1MaxPersonIndex:-1,
						// 从0开始
						index2MaxPersonIndex:-1,
						index5PlanShow:false,
						curUserInfo:{},
						lastData:{},
						isZh:true,
						curSelect:false,
						startX:-1,
						// 请同步修改zh.js，en.js
            datas:[
                {
                    key:'1',
                    title:'经办企业',
                    quest:'1、您是否以个人名义或通过他人，以独立或合资方式，或以承包、租赁等模式<span class="font_bold">从事商业活动或创办企业</span>？',
                    whether:'',
										describe:'',
										persons:[{type:'本人',companys:[{}]}]
                },
                {
                    key:'2',
                    title:'亲属经办企业与公司利益冲突',
                    quest:'2、您的直系亲属（包括配偶、子女、以及您和配偶的父母）是否以个人名义或与他人合资的方式<span class="color_red">（含通过控股公司、代持股份等间接方式）</span><span class="font_bold">从事商业活动或创办企业，并且与三一集团有限公司的下属公司存在业务交易，或与三一集团经营的业务存在竞争关系</span>？（公开市场上的股票、基金、债券及其衍生品投资，以及房产投资除外）',
                    whether:'',
										describe:'',
										companys:[{persons:[{}]}]
                },
                {
                    key:'3',
                    title:'任职与兼职',
                    quest:'3、您或您的直系亲属是否<span class="font_bold">在供应商、客户、代理商、竞争方任职、兼职</span>（包括以咨询、顾问或<span class="color_red">名誉职务等</span>其他类似身份从事的活动，不包括证书挂靠形式）。',
                    whether:'',
										describe:'',
										companys:[{persons:[{}]}]
                },
                {
                    key:'4',
                    title:'经济往来',
                    quest:'4、您或您的直系亲属是否与您职权范围内的业务往来个人或单位（不包括银行机构）存在借款、贷款、<span class="color_red">融资担保或商业交易（含赊销、分期付款等非即时结清交易）</span>或商务买卖行为？',
                    whether:'',
										describe:'',
										persons:[{}]
                },
                {
                    key:'5',
                    title:'职务便利',
                    quest:'5、您是否<span class="font_bold">利用自身职权范围影响力或管辖公司资源</span>，帮助个人及其亲属、同学、朋友等获取利益或相应的机会。（如商务人员介绍亲朋在自己管辖的供应商处任职，公司领导干部安排亲朋在自己手下任职等）',
                    whether:'',
										describe:'',
										companys:[{persons:[{}]}]
                },
                {
                    key:'6',
                    title:'亲属关系',
                    quest:'6、在您入职前或入职后，您是否有以下亲属在公司任职？<br/><br/>包括：您配偶、您及配偶的父母、子女（及其配偶及配偶的父母）、祖父母/外祖父母；外甥/外甥女（及其配偶）；继父母、继子女（及其配偶及配偶的父母）；养父母、养子女（及其配偶及配偶的父母）；您及配偶的兄弟姐妹（及其配偶）；伯父/伯母；叔叔/婶婶；姑父/姑母；堂兄弟姐妹（及其配偶）；舅父/舅母；姨父/姨母；表兄弟姐妹（及其配偶）；侄子侄女（及其配偶）。',
                    whether:'',
                    describe:'',
										persons:[{}]
                },
                {
                    key:'7',
                    title:'保密与竞业协议',
                    quest:'7、您是否在入职本公司之前与原用人单位签订了<span class="font_bold">技术保密或竞业限制协议</span>，并且该协议目前仍在有效期内？',
                    whether:'',
                    describe:''
                },
                {
                    key:'8',
                    title:'介绍业务',
                    quest:'8、您作为董事、关键岗位或核心岗位的人员，或您的关系人（包括亲友、同学、老乡）是否曾介绍供应商与三一公司开展业务？（包括基建施工、采购、外协、零部件加工，<span class="color_red">包括提供供应商推荐、参与供应商资质审核等环节</span>）',
                    whether:'',
										describe:'',
										persons:[{businesss:[{}]}]
                },
                {
                    key:'9',
                    title:'其他',
                    quest:'9、最近36个月内，您是否涉及<span class="font_bold">违反廉洁从业规定</span>的行为？（包括不限于吃拿卡要、弄虚作假、贪污受贿、挪用侵占、损害公司声誉、泄露公司秘密、串通投标、接受关联方宴请或礼金、其它舞弊行为）',
                    whether:'',
										describe:'',
										persons:[{}]
                }
						],
						verEns:{
							'请填写投资信息':'Please fill in the investment information',
							'企业信息的企业名称':'Company name of company information',
							'投资信息':'Investment Information',
							'企业信息的统一社会信用代码未获取，可通过点击企业名称后的放大镜获取':'The unified social credit code of the enterprise information has not been obtained, but can be obtained by clicking the magnifying glass after the enterprise name',
							'企业信息的投资模式':'Investment Model of Enterprise Information',
							'企业信息的其他':'Corporate Information Other',
							'请填写关系人信息的关系':'Please fill in the information of the relationship',
							'请填写关系人信息的姓名':'Please fill in the name of the relevant person information',
							'请填写关系人信息的投资类型':'Please fill in the investment type of the related person information',
							'请填写关系人信息的企业名称':'Please fill in the company name of the related person information',
							'关系人信息的统一社会信用代码未获取，可通过点击企业名称后的放大镜获取':'The unified social credit code of the related person information has not been obtained, but can be obtained by clicking the magnifying glass after the company name',
							'请填写关系人信息的与三一集团的关系':'Please fill in the relationship information of the relationship with SANY Group',
							'请填写关系人信息的手机号':'Please fill in the mobile phone number of the relevant person information',
							'请填写关系人信息的任职岗位':'Please fill in the position of the relevant person information',
							'请填写关系人信息的企业关系':'Please fill in the information of the related person for the corporate relationship',
							'请填写人员信息的关系':'Please fill in the relationship of personnel information',
							'请填写人员信息的姓名':'Please fill in the name of the personnel information',
							'请填写人员信息的手机号':'Please fill in the mobile phone number of personnel information',
							'请填写人员信息的往来类型':'Please fill in the type of personnel information',
							'请填写人员信息的个人姓名':'Please fill in the personal name of the person information',
							'请填写人员信息的联系电话':'Please fill in the contact number of personnel information',
							'请填写人员信息的企业名称':'Please fill in the company name of the personnel information',
							'请填写企业信息的任职单位类型':'Please fill in the company information of the type of employer',
							'请选择企业信息的部门':'Please select the department of corporate information',
							'请填写企业信息':'Please fill in the company information',
							'关系人信息的关系':'Relational Person Information Relation',
							'请选择企业信息':'Please select company information',
							'关系人信息的姓名':'Name of Related Person Information',
							'企业信息的统一社会信用代码未获取，可通过点击企业名称后的放大镜获取':'The unified social credit code of the enterprise information has not been obtained, but can be obtained by clicking the magnifying glass after the enterprise name',
							'关系人信息的手机号':'Mobile phone number of related person information',
							'关系人信息的任职岗位':'Job Position of Related Person Information',
							'请选择职工信息的关系':'Please select Employee Information Relationship',
							'请选择职工信息的姓名':'Please select the name of the employee information',
							'请选择职工信息':'Please select employee information',
							'请填写备注说明':'Please fill in the remarks',
							'请选择人员信息的关系':'Please select the relationship of person information',
							'请填写人员信息':'Please fill in personnel information',
							'关系人信息的企业名称':'Company name of related party information',
							'关系人信息的业务类型':'Business Types of Relationship Information',
							'请选择人员信息的干系人':'Please select the stakeholders of the personnel information',
							'请选择人员信息的事项描述':'Please select the item description of personnel information',
							'人员信息的统一社会信用代码未获取，可通过点击企业名称后的放大镜获取':'The unified social credit code of personnel information is not obtained, but can be obtained by clicking the magnifying glass after the company name',
							'请选择人员信息的手机号':'Please select the mobile number of the personnel information',
							'请选择人员信息的姓名':'Please select the name of the person information',
							'人员信息':'Personnel information',
							'关系人信息的业务描述':'Business description of related person information',
							'投资信息的手机号无效，手机号只能包含数字和+-符号':'The mobile phone number of the personnel information is invalid, and the mobile phone number can only contain numbers and + - symbols',
							'请填写投资信息的姓名':'Please fill in the name of the investment information',
							'请填写投资信息的手机号':'Please fill in the mobile number of the investment information',
							'':'',
							'':'',

						}
        }
    },

    created(){

			// let arr = ['基建施工','采购','外协','零部件加工','供应商相关','其他']
			// let arr2 = ['Infrastructure Construction ',' Procurement ',' Outsourcing ',' Parts Processing ',' Supplier Related ',' Others']
			// arr.forEach((item,index)=>{
			// 	console.log(`'${item}':'${arr2[index].trim()}',`)
			// })



			// if(this.isZh){
			// 	Object.keys(this.$ens).forEach(item=>{
			// 		this.$ens[item] = item
			// 	})
			// }
			this.isZh = this.i18n.locale != 'en'
			console.log('yzk',window.innerWidth)
			console.log({
				innerWidth: window.innerWidth,
				screenWidth: window.screen.width,
				devicePixelRatio: window.devicePixelRatio,
				availWidth: window.screen.availWidth
			});
			document.title = this.$en('利益冲突申报')
			this.curUserInfo = JSON.parse(localStorage.getItem('userInfo'))
			this.datas = this.datas.map(item=>{
				item.title = this.$t('sbItemTitle'+item.key)
				item.quest = this.$t('sbItemQuest'+item.key)
				return item
			})
			document.addEventListener('selectionchange',()=>{
				let select = window.getSelection().toString()
				this.curSelect=select?true:false
			})
		},
    mounted(){
        this.$http.get('/api/ts/v0.1/interest/lastData')
        .then(res=>{
            console.log(res)
            if(res.data){
							this.lastData = res.data
							let currentPage = this.$route.query.currentPage
							if(currentPage){
								currentPage-=1
								this.currentPage = parseInt(currentPage)
								this.receiptEvent()
								this.$nextTick(()=>{
									this.$refs.swipe.swipeTo(this.currentPage)
								})
							}
						}
						// this.fillDatas()
        })
    },
    methods:{
		openLoading(){
			Toast.loading({
				message:this.i18n.locale=='en'?'Loading...........':'加载中。。。',
				forbidClick:true,
				overlay:true,
				duration:30000
			})
		},
		closeLoading(){
			Toast.clear()
		},
        changeLanguage(click){
            let lang = this.i18n.locale
            if(lang=='en'){
                lang = 'zh'
            }else{
                lang = 'en'
						}
            this.$changeLocales(lang)
						Toast.loading({
							message:lang=='en'?'Loading...........':'加载中。。。',
							forbidClick:true,
							overlay:true,
							duration:30000
						})
						if(click){
							window.location.reload()
						}
        },
			// touchMoveStart(event){
			// 	if(this.curSelect){
			// 		this.$message.info('当前处于复制模式，无法滑动，请取消复制或点击下一步！！！')
			// 	}
			// 	// this.startX = event.changedTouches[0].screenX
			// },
			// // touchMoveEnd(event){
			// // },
			// touchMove(event){
			// 	// alert(event)
			// },
			async getUserInfo(oguGuid){
				if(!oguGuid){
					return {}
				}
				let userList = await this.$http.get('/api/orgPerson/v0.1/orgPerson/getUserList',{
					params:{
						oguGuids:oguGuid
					}
				})
				if(userList&&userList.data&&userList.data.list&&userList.data.list.length>0){
					return userList.data.list[0]
				}
				return {}
			},
			async getOrgInfo(orgGuid){
				if(!orgGuid){
					return {}
				}
				let orgInfo = await this.$http.get('/api/orgPerson/v0.1/org/getOrgByGuid',{
					params:{
						orgGuid:orgGuid
					}
				})
				return orgInfo.data.data||{}
			},
			companyType4Select(companyType,index){
				let old = this.datas[4].companys[index].companyType
				let isChange = ( old == '内部'?1:0+companyType ==' 内部'?1:0)==1
				this.datas[4].companys[index].companyType = companyType
				if(isChange&&this.datas[4].companys[index].companyId){
					this.datas[4].companys[index].companyId = ''
				}
				if(isChange){
					if(this.datas[4].companys[index].companyName){
						this.datas[4].companys[index].companyName = ''
					}
				}
				this.datas[4].companys[index].persons.forEach(item=>{
					if(isChange){
						if(item.personNo){
							item.personNo = ''
						}
						if(item.position){
							item.position = ''
						}
						if(item.personPhone){
							item.personPhone = ''
						}
						if(item.personName){
							item.personName = ''
						}
					}
				})
				// this.datas[4].companys[index].persons = this.datas[4].companys[index].persons.map(item=>{
				// 	if(isChange){
				// 		if(item.personNo){
				// 			item.position = ''
				// 		}
				// 		if(item.position){
				// 			item.position = ''
				// 		}
				// 		if(item.personPhone){
				// 			item.position = ''
				// 		}
				// 		if(item.personName){
				// 			item.position = ''
				// 		}
				// 	}
				// 	return item
				// })
			},
			index0ModeSelect(mode,personIndex,companyIndex){
				this.datas[0].persons[personIndex].companys[companyIndex].mode = mode
				if(this.datas[0].persons[personIndex].companys[companyIndex].ratio){
					this.datas[0].persons[personIndex].companys[companyIndex].ratio = ''
				}
				if(this.datas[0].persons[personIndex].companys[companyIndex].other){
					this.datas[0].persons[personIndex].companys[companyIndex].other = ''
				}
			},
			index1AddPerson(companyIndex,personIndex){
				this.Dialog.confirm({
					title:this.$t('tx'),
					message:this.$en('请问需要添加的关系人是当前企业的吗？'),
					cancelButtonText:this.$en('否'),
					confirmButtonText:this.$en('是')
				}).then(()=>{
					this.datas[1].companys[companyIndex].persons.push({})
					this.resetIndex1PersonIndex()
					this.$message.success(this.$en('添加成功'))
				}).catch(()=>{
					this.datas[1].companys.push({persons:[{}]})
					this.resetIndex1PersonIndex()
					this.$message.success(this.$en('添加成功'))
				})
			},
			index1DeletePerson(companyIndex,personIndex){
				let persons = this.datas[1].companys[companyIndex].persons
				if(persons.length<=1){
					this.datas[1].companys.splice(companyIndex,1)
				}else{
					persons.splice(personIndex,1)
				}
				this.resetIndex1PersonIndex()
				this.$message.success(this.$en('删除成功'))
			},
			resetIndex1PersonIndex(){
				let index = -1;
				this.datas[1].companys.forEach((company,companyIndex)=>{
					company.persons.forEach((person,personIndex)=>{
						person.curPersonIndex = ++index
					})
				})
				this.index1MaxPersonIndex = index
			},
			index2AddPerson(companyIndex,personIndex){
				this.Dialog.confirm({
					title:this.$t('tx'),
					message:this.$en('请问需要添加的关系人是当前企业的吗？'),
					cancelButtonText:this.$en('否'),
					confirmButtonText:this.$en('是')
				}).then(()=>{
					this.datas[2].companys[companyIndex].persons.push({})
					this.resetIndex2PersonIndex()
					this.$message.success(this.$en('添加成功'))
				}).catch(()=>{
					this.datas[2].companys.push({persons:[{}]})
					this.resetIndex2PersonIndex()
					this.$message.success(this.$en('添加成功'))
				})
			},
			index2DeletePerson(companyIndex,personIndex){
				let persons = this.datas[2].companys[companyIndex].persons
				if(persons.length<=1){
					this.datas[2].companys.splice(companyIndex,1)
				}else{
					persons.splice(personIndex,1)
				}
				this.resetIndex2PersonIndex()
				this.$message.success(this.$en('删除成功'))
			},
			resetIndex2PersonIndex(){
				let index = -1;
				this.datas[2].companys.forEach((company,companyIndex)=>{
					company.persons.forEach((person,personIndex)=>{
						person.curPersonIndex = ++index
					})
				})
				this.index2MaxPersonIndex = index
			},
			async selectType(index,value){
				this.$set(this.datas[0].persons[index],'personName','')
				if(value=='本人'){
					// this.datas[0].persons[index].personNo = this.curUserInfo.orgUserGuid
					// this.datas[0].persons[index].personName = this.curUserInfo.oguName
					this.$set(this.datas[0].persons[index],'personNo',this.curUserInfo.orgUserGuid)
					this.$set(this.datas[0].persons[index],'personName',this.curUserInfo.oguName)
					let userInfo = await this.getUserInfo(this.curUserInfo.orgUserGuid)
					this.$set(this.datas[0].persons[index],'personPhone',userInfo.U_PHONE)
				}else{
					// this.datas[0].persons[index].personNo = ''
					this.$set(this.datas[0].persons[index],'personNo','')
					this.$set(this.datas[0].persons[index],'personPhone','')
				}
				this.datas[0].persons[index].type = value
				this.$forceUpdate()
			},
			async index4PersonSelect(person,companyIndex,personIndex){
				this.datas[4].companys[companyIndex].persons[personIndex].orgGuid = person.ORG_GUID
				this.datas[4].companys[companyIndex].persons[personIndex].orgName = person.ORG_NAME
				this.datas[4].companys[companyIndex].persons[personIndex].postGuid = person.OGU_RANK_GUID
				this.datas[4].companys[companyIndex].persons[personIndex].position = person.OGU_RANK_NAME
				let userInfo = await this.getUserInfo(person.OGU_GUID)
				this.datas[4].companys[companyIndex].persons[personIndex].personPhone = userInfo.U_PHONE
			},
			async index5PersonSelect(person,index){
				this.datas[5].persons[index].orgGuid = person.ORG_GUID
				this.datas[5].persons[index].orgName = person.ORG_NAME
				this.datas[5].persons[index].postGuid = person.OGU_RANK_GUID
				this.datas[5].persons[index].postName = person.OGU_RANK_NAME
				let orgInfo = await this.getOrgInfo(person.ORG_GUID)
				this.datas[5].persons[index].orgFullPath = orgInfo.orgFullPath
				this.datas[5].persons[index].orgFullPathName = orgInfo.orgFullPathName
				let userInfo = await this.getUserInfo(person.OGU_GUID)
				this.datas[5].persons[index].personPhone = userInfo.U_PHONE
			},
			async index8PersonSelect(person,index){
				this.datas[8].persons[index].orgGuid = person.ORG_GUID
				this.datas[8].persons[index].orgName = person.ORG_NAME
				this.datas[8].persons[index].postGuid = person.OGU_RANK_GUID
				this.datas[8].persons[index].postName = person.OGU_RANK_NAME
				let orgInfo = await this.getOrgInfo(person.ORG_GUID)
				this.datas[8].persons[index].orgFullPath = orgInfo.orgFullPath
				this.datas[8].persons[index].orgFullPathName = orgInfo.orgFullPathName
				let userInfo = await this.getUserInfo(person.OGU_GUID)
				this.datas[8].persons[index].personPhone = userInfo.U_PHONE
			},
			index3CommunicationTypeSelect(communicationType,personIndex){
				this.datas[3].persons[personIndex].communicationType = communicationType
				if(this.datas[3].persons[personIndex].communicationPersonName){
					this.datas[3].persons[personIndex].communicationPersonName = ''
				}
				if(this.datas[3].persons[personIndex].communicationPersonPhone){
					this.datas[3].persons[personIndex].communicationPersonPhone = ''
				}
				if(this.datas[3].persons[personIndex].companyId){
					this.datas[3].persons[personIndex].companyId = ''
				}
				if(this.datas[3].persons[personIndex].companyName){
					this.datas[3].persons[personIndex].companyName = ''
				}
			},
			async relationshipSelect7(val,index){
				let data = JSON.parse(JSON.stringify(this.datas[7].persons[index]))
				data.relationship = val
				if(val=='本人'){
					data.personNo = this.curUserInfo.orgUserGuid
					data.personName = this.curUserInfo.oguName
					let userInfo = await this.getUserInfo(this.curUserInfo.orgUserGuid)
					data.personPhone = userInfo.U_PHONE
					// this.$set(data,'personPhone',userInfo.uPhone)
					// this.$forceUpdate()
				}else{
					data.personNo = ''
					data.personName = ''
					data.personPhone = ''
				}
				// debugger
				// this.datas[7].persons[index] = data
				this.$set(this.datas[7].persons,index,data)
				// this.$forceUpdate()
			},
			async verData(pageIndex){
				let data = this.datas[pageIndex]
				if(!data.whether){
					return this.$en('请选择是否有申报关联！')
				}
				if(data.whether=='否'){
					return
				}
				let err = ''
				if(pageIndex==0){
					if(!data.persons||data.persons.length==0){
						console.log('手动添加')
						return '请添加人员信息！'
					}
					data.persons.forEach((person,index)=>{
						let label = '投资信息'+(data.persons.length>1?index+1:'')
						if(!person.type){
							err = err?err:`请填写${label}的类型`
						}
						if(person.type=='本人'){
							this.selectType(index,'本人')
							// if(!person.personName){
							// 	err = err?err:`请填写${label}的姓名`
							// }
							// if(!person.personNo){
							// 	err = err?err:`请填写${label}的工号`
							// }
						}else if(person.type=='他人名义'){
							if(!person.personName){
								err = err?err:`请填写${label}的姓名`
							}
							if(!person.personPhone){
								err = err?err:`请填写${label}的手机号`
							}
							if(!this.isValidPhone(person.personPhone)){
								err = err?err:`${label}的手机号无效，手机号只能包含数字和+-符号`
							}
						}
						if(!person.companys||person.companys.length==0){
							console.log('手动添加')
							err = err?err:'请添加企业名称！'
						}
						person.companys.forEach((company,i)=>{
							let labelSon = label+'-企业信息'+(person.companys.length>1?i+1:'')
							if(!company.companyName){
								err = err?err:`请填写${labelSon}的企业名称`
							}
							if(!company.companyId){
								err = err?err:`${labelSon}的统一社会信用代码未获取，可通过点击企业名称后的放大镜获取`
							}
							if(!company.mode){
								err = err?err:`请填写${labelSon}的投资模式`
							}
							if(company.mode=='合资/合股'){
								// if(company.ratio==null||company.ratio==undefined||company.ratio===''){
								// 	err = err?err:`请填写${labelSon}的占比`
								// }
							}else if(company.mode=='其他'){
								if(!company.other){
									err = err?err:`请填写${labelSon}的其他`
								}
							}
						})
					})
				}else if(pageIndex==1){
					if(!data.companys||data.companys.length==0){
						console.log('手动添加')
						return '请添加企业信息！'
					}
					data.companys.forEach((company,index)=>{
						let label = ''
						company.persons.forEach((person,i)=>{
							let labelSon = '关系人信息'+(this.index1MaxPersonIndex>0?person.curPersonIndex+1:'')
							label = label?label:labelSon
							// if(person.investmentType=='合资/合股'){
							// 	if(person.ratio==null||person.ratio==undefined||person.ratio===''){
							// 		err = err?err:`请填写${labelSon}的占比`
							// 	}
							// }
							if(!person.relationship){
								err = err?err:`请填写${labelSon}的关系`
							}
							if(!person.name){
								err = err?err:`请填写${labelSon}的姓名`
							}
							// if(!person.idCard){
							// 	err = err?err:`请填写${labelSon}的身份证号`
							// }
							// if(!this.isValidID(person.idCard)){
							// 	err = err?err:`${labelSon}的身份证号无效`
							// }
							if(!person.investmentType){
								err = err?err:`请填写${labelSon}的投资类型`
							}
						})
						if(!company.companyName){
							err = err?err:`请填写${label}的企业名称`
						}
						if(!company.companyId){
							err = err?err:`${label}的统一社会信用代码未获取，可通过点击企业名称后的放大镜获取`
						}
						if(!company.companyRelationship){
							err = err?err:`请填写${label}的与三一集团的关系`
						}
					})
				}else if(pageIndex==2){
					if(!data.companys||data.companys.length==0){
						console.log('手动添加')
						return '请添加企业信息！'
					}
					data.companys.forEach((company,index)=>{
						let label = ''
						company.persons.forEach((person,i)=>{
							let labelSon = '关系人信息'+(this.index2MaxPersonIndex>0?person.curPersonIndex+1:'')
							label = label?label:labelSon
							if(!person.relationship){
								err = err?err:`请填写${labelSon}的关系`
							}
							if(!person.personName){
								err = err?err:`请填写${labelSon}的姓名`
							}
							if(!person.personPhone){
								err = err?err:`请填写${labelSon}的手机号`
							}
							if(!this.isValidPhone(person.personPhone)){
								err = err?err:`${labelSon}的手机号无效，手机号只能包含数字和+-符号`
							}
							if(!person.position){
								err = err?err:`请填写${labelSon}的任职岗位`
							}
						})
						if(!company.companyName){
							err = err?err:`请填写${label}的企业名称`
						}
						if(!company.companyId){
							err = err?err:`${label}的统一社会信用代码未获取，可通过点击企业名称后的放大镜获取`
						}
						if(!company.corporateRelations){
							err = err?err:`请填写${label}的企业关系`
						}
					})
				}else if(pageIndex==3){
					if(!data.persons||data.persons.length==0){
						console.log('手动添加')
						return '请添加人员信息！'
					}
					data.persons.forEach((person,index)=>{
						let label = '人员信息'+(data.persons.length>1?index+1:'')
						if(!person.relationship){
							err = err?err:`请填写${label}的关系`
						}
						if(!person.personName){
							err = err?err:`请填写${label}的姓名`
						}
						if(!person.personPhone){
							err = err?err:`请填写${label}的手机号`
						}
						if(!this.isValidPhone(person.personPhone)){
							err = err?err:`${label}的手机号无效，手机号只能包含数字和+-符号`
						}
						if(!person.communicationType){
							err = err?err:`请填写${label}的往来类型`
						}
						if(person.communicationType=='往来公司'){
							if(!person.companyName){
								err = err?err:`请填写${label}的企业名称`
							}
							if(!person.companyId){
								err = err?err:`${label}的统一社会信用代码未获取，可通过点击企业名称后的放大镜获取`
							}
						}else if(person.communicationType=='往来个人'){
							if(!person.communicationPersonName){
								err = err?err:`请填写${label}的个人姓名`
							}
							if(!person.communicationPersonPhone){
								err = err?err:`请填写${label}的联系电话`
							}
						}
					})
				}else if(pageIndex==4){
					if(!data.companys||data.companys.length==0){
						console.log('手动添加')
						return '请添加企业信息！'
					}
					data.companys.forEach((company,index)=>{
						let label = '企业信息'+(data.companys.length>1?index+1:'')
						if(!company.persons||company.persons.length==0){
							console.log('手动添加')
							return '请添加人员信息！'
						}
						if(!company.companyType){
							err = err?err:`请填写${label}的任职单位类型`
						}
						if(company.companyType=='内部'){
							if(!company.companyId){
								err = err?err:`请选择${label}的部门`
							}
							if(!company.companyName){
								err = err?err:`请选择${label}的部门`
							}
						}else{
							if(!company.companyId){
								err = err?err:`${label}的统一社会信用代码未获取，可通过点击企业名称后的放大镜获取`
							}
							if(!company.companyName){
								err = err?err:`请填写${label}的企业名称`
							}
						}
						company.persons.forEach((person,i)=>{
							let labelSon = label+'-关系人信息'+(company.persons.length>1?i+1:'')
							if(!person.relationship){
								err = err?err:`请填写${labelSon}的关系`
							}
							if(company.companyType=='内部'){
								if(!person.personNo){
									err = err?err:`请选择${labelSon}的姓名`
								}
							}else{
								if(!person.personName){
									err = err?err:`请填写${labelSon}的姓名`
								}
								if(!person.personPhone){
									err = err?err:`请填写${labelSon}的手机号`
								}
								if(!this.isValidPhone(person.personPhone)){
									err = err?err:`${labelSon}的手机号无效，手机号只能包含数字和+-符号`
								}
								if(!person.position){
									err = err?err:`请填写${labelSon}的任职岗位`
								}
							}
						})

					})
				}else if(pageIndex==5){
					if(!data.persons||data.persons.length==0){
						console.log('手动添加')
						return '请添加职工信息！'
					}
					data.persons.forEach((person,index)=>{
						let label = '职工信息'+(data.persons.length>1?index+1:'')
						if(!person.relationship){
							err = err?err:`请选择${label}的关系`
						}
						if(!person.personNo){
							err = err?err:`请选择${label}的姓名`
						}
					})
				}else if(pageIndex==6){
					if(!data.describe){
						err = err?err:'请填写备注说明'
					}
				}else if(pageIndex==7){
					if(!data.persons||data.persons.length==0){
						console.log('手动添加')
						return '请添加人员信息！'
					}
					data.persons.forEach((person,index)=>{
						let label = '人员信息'+(data.persons.length>1?index+1:'')
						if(!person.relationship){
							err = err?err:`请选择${label}的关系`
						}
						if(!person.personName){
							err = err?err:`请选择${label}的姓名`
						}
						if(!person.personPhone){
							err = err?err:`请选择${label}的手机号`
						}
						if(!this.isValidPhone(person.personPhone)){
							err = err?err:`${label}的手机号无效，手机号只能包含数字和+-符号`
						}
						person.businesss.forEach((business,i)=>{
							let labelSon = label+'-关系人信息'+(person.businesss.length>1?i+1:'')
							if(!business.companyName){
								err = err?err:`请填写${labelSon}的企业名称`
							}
							if(!business.companyId){
								err = err?err:`${labelSon}的统一社会信用代码未获取，可通过点击企业名称后的放大镜获取`
							}
							if(!business.businessType){
								err = err?err:`请填写${labelSon}的业务类型`
							}
							if(!business.position){
								err = err?err:`请填写${labelSon}的业务描述`
							}
						})
					})
				}else if(pageIndex==8){
					if(!data.persons||data.persons.length==0){
						console.log('手动添加')
						return '请添加人员信息！'
					}
					data.persons.forEach((person,index)=>{
						let label = '人员信息'+(data.persons.length>1?index+1:'')
						if(!person.personNo){
							err = err?err:`请选择${label}的干系人`
						}
						if(!person.itemDesc){
							err = err?err:`请选择${label}的事项描述`
						}
					})
				}
				return await this.getEnByVerText(err)
			},
			async getEnByVerText(text){
				if(!text){
					return text
				}
				if(this.isZh){
					return text
				}
				let t = this.verEns[text]
				if(t){
					return t
				}
				let sText = text
				let arr = text.split(/-+/)
				let hasZh = false
				arr.forEach(item=>{
					let en = this.verEns[item]
					if(!en){
						hasZh = true
						return
					}
					// if(!en){
					// 	this.enLabelss.add(item)
					// 	console.log(this.enLabelss)
					// }
					// let en = this.$ens[item]
					text = text.replace(item,` ${en||item} `)
				})
				if(!hasZh){
					return text
				}
				Toast.loading({
					message:this.$en('加载中。。。'),
					forbidClick:true,
					duration:30000
				})
				try{
					let res = await this.$http.post('/api/job/v0.1/jobCommon/getNoCrossOriginJsonData',{
						body:JSON.stringify([{text:sText}]),
						headers: JSON.stringify({authKey:'8ce9ab64-28b9-44dc-baad-5130ef5f4591'}),
						type: "post",
						url: "http://ipaas-esb.sany.com.cn/open/oapi_ms/translate?to=en&api-version=3.0"
					})
					return res.data[0].translations[0].text
				}catch(err){
					return this.$en('操作失败，请联系管理员（田辉阳）')
				}finally{
					Toast.clear()
				}

				// text = text.replace('-',' - ')
				// console.log(sText)
				// console.log(text)
				// let arr = text.split(/[\d-]+/)
				// arr[0] = arr[0].replace('请填写','')
				// arr[0] = arr[0].replace('请选择','')
				// text = text.replace('请填写','Please fill in the ')
				// text = text.replace('请选择','Please select ')
				// text = text.replace('-',' - the ')
				// arr.forEach((item)=>{
				// 	if(!item){
				// 		return
				// 	}
				// 	let en = this.$ens[item]
				// 	if(en){
				// 		text = ' '+text.replace(item,en.toLowerCase())
				// 	}else if(item.indexOf('的')>-1){
				// 		let t = item.split('的')
				// 		text = text.replace(item,this.$ens[t[1]].toLowerCase()+' of '+this.$ens[t[0]].toLowerCase())
				// 	}
				// })

				return text
			},
			fillDatas(){
				console.log('datas:',this.datas)
				this.$set(this,'datas',
				// this.datas =
					this.datas.map(item=>{
						switch (item.key){
							case '1':
								if(!item.persons||item.persons.length==0){
									item.persons = [{}]
								}
								item.persons = item.persons.map(itm=>{
									if(!itm.companys||itm.companys.length==0){
										itm.companys = [{}]
									}
									return itm
								})
								break;
							case '2':
								if(!item.companys||item.companys.length==0){
									item.companys = [{}]
								}
								item.companys = item.companys.map(itm=>{
									if(!itm.persons||itm.persons.length==0){
										itm.persons = [{}]
									}
									return itm
								})
								break;
							case '2':
								break;
							case '2':
								break;
							case '2':
								break;
							case '2':
								break;
							case '2':
								break;
							case '2':
								break;
							case '2':
								break;
						}
						return item
					})
				)
				// this.$forceUpdate()
				console.log('datas:',this.datas)
			},
			showPicker(cols,v,call){
				if(!this.isZh){
					cols = cols.map(item=>{
						return {text:this.$en(item),key:item}
					})
				}
				this.pickerColumns = cols
				if(v){
					this.pickerDefIndex = cols.findIndex(item=>{
						if(!this.isZh){
							return item.key == v
						}
						return item == v
					})
				}else{
					this.pickerDefIndex = 0
				}
				this.pickerCall = call
				if(this.isPC){
					this.pcPickerShow = true
				}else{
					this.pickerShow = true
				}
			},
			pcPickerSelect(idx,col){
				this.pickerDefIndex = idx
				if(this.pickerCall){
					if(typeof col == 'string'){
						this.pickerCall(col)
					}else{
						this.pickerCall(col.key?col.key:col.text)
					}
				}
				this.pcPickerShow = false
			},
			pickerConfirm(val){
				if(this.pickerCall){
					if(typeof val == 'string'){
						this.pickerCall(val)
					}else{
						this.pickerCall(val.key?val.key:val.text)
					}
				}
				this.pickerShow = false
			},
        //我接受
        receiptEvent(){
					this.isShow = 1
					// return
					if(this.lastData&&this.lastData.guid){
						this.Dialog.confirm({
							title:this.$en('提醒'),
							// message:`检测到您在 ${this.$handlerDateToDay(this.lastData.created)} 有${this.lastData.declareDate?'申报':'暂存'}数据，您需要填充到当前的申报数据上吗？`,
							message:this.$t('tctx',{date:this.$handlerDateToDay(this.lastData.created),type:this.lastData.declareDate?this.$t('tempSb'):this.$t('tempZc')}),
							cancelButtonText:this.$en('不填充'),
							confirmButtonText:this.$en('填充')
						}).then(()=>{
							if(this.lastData.files){
								this.fileList = this.lastData.files.split(',')
							}else{
								this.fileList = []
							}
							this.lastData.files = ''
							let datas = JSON.parse(this.lastData.form)
							this.datas = this.datas.map((item,index)=>{
								let d = datas.find(itm=>{
									return itm&&itm.key==item.key
								})
								d.quest = item.quest
								d.title = item.title
								Object.assign(item,d)
								return item
							})
							this.resetIndex1PersonIndex()
							this.resetIndex2PersonIndex()
							this.$message.info({message:this.$en('已填充成功，如需取消请刷新页面'),duration:1500})
						}).catch(()=>{
							this.$message.info({message:this.$en('已取消填充，如需填充请刷新页面'),duration:1500})
						})
					}
        },

        //选择答案
        selectItemEvent(index, type){
            this.$set(this.datas[index], 'whether', type)
        },

        // 轮播图切换
        async swipeChangeEvent(val){
            console.log(val)
            console.log(this.currentPage)
            if(this.currentPage < val){
							let err = ''
							err = err?err:await this.verData(this.currentPage)
							if(err){
								this.Dialog.alert({
									title:this.$en('警告'),
									message:err
								})
								return this.$refs.swipe.swipeTo(this.currentPage)
							}
							this.currentPage = val
                // if(this.datas[this.currentPage].whether == ''){
                //     this.$message.error('请选择是否有申报关联！')
                //     this.$refs.swipe.swipeTo(this.currentPage)
                // }else{
                //     if(this.datas[this.currentPage].whether == this.$en('是')){
                //         if(this.datas[this.currentPage].describe == ''){
                //             this.$message.error('请填写申报事项描述！')
                //             this.$refs.swipe.swipeTo(this.currentPage)
                //         }else{
                //             this.currentPage = val
                //         }
                //     }else{
                //         this.currentPage = val
                //     }
                    
                // }
            }else{
                this.currentPage = val
            }
            
        },

        //页码增加
        async pageAddEvent(){
						console.log(this.currentPage)
						let err = await this.verData(this.currentPage)
						if(err){
							this.Dialog.alert({
								title:this.$en('警告'),
								message:err
							})
						}else{
							this.$refs.swipe.swipeTo(this.currentPage + 1)
							this.currentPage += 1
						}
            // if(this.datas[this.currentPage].whether == ''){
            //     this.$message.error('请选择是否有申报关联！')
            // }else{
            //     if(this.datas[this.currentPage].whether == this.$en('是')){
            //         if(this.datas[this.currentPage].describe == ''){
            //             this.$message.error('请填写申报事项描述！')
            //         }else{
            //             this.$refs.swipe.swipeTo(this.currentPage + 1)
            //             this.currentPage += 1
            //         }
            //     }else{
            //         this.$refs.swipe.swipeTo(this.currentPage + 1)
            //         this.currentPage += 1
            //     }
                
            // }
            
        },

        //页码减少
        pageMuteEvent(){
            console.log(this.currentPage)
            this.$refs.swipe.swipeTo(this.currentPage - 1)
            this.currentPage -= 1
        },

        //下一步
        async nextStepEvent(){
						console.log(this.datas)
						let err = await this.verData(8)
						if(err){
							this.Dialog.alert({
								title:this.$en('警告'),
								message:err
							})
						}else{
							this.datas[0].persons.forEach(item=>{
								item.show = false
							})
							this.datas[1].companys.forEach(item=>{
								item.show = false
							})
							this.datas[2].companys.forEach(item=>{
								item.show = false
							})
							this.datas[3].persons.forEach(item=>{
								item.show = false
							})
							this.datas[4].companys.forEach(item=>{
								item.show = false
							})
							this.datas[5].persons.forEach(item=>{
								item.show = false
							})
							this.datas[7].persons.forEach(item=>{
								item.show = false
							})
							this.datas[8].persons.forEach(item=>{
								item.show = false
							})
							this.isShow = 2
						}
            // if(this.datas[8].whether == ''){
            //     this.$message.error('请选择是否有申报关联！')
            // }else{
            //     if(this.datas[8].whether == this.$en('是')){
            //         if(this.datas[8].describe == ''){
            //             this.$message.error('请填写申报事项描述！')
            //         }else{
            //             this.isShow = 2
            //         }
            //     }else{
            //         this.isShow = 2
            //     }
                
            // }
            
        },

        //上一步
        proidStepEvent(){
            this.isShow = 1
            this.currentPage = 0
        },
        onSubmit(temp = false){
					console.log(this.datas)
					this.Dialog.confirm({
							title:this.$en('警告'),
							message:temp?this.$en('请确认是否暂存'):this.$en('请确认是否提交数据，提交后数据将不能修改。')
					}).then(()=>{
							this.openLoading()
							let form = {}
							form.form = JSON.stringify(JSON.parse(JSON.stringify(this.datas)).map(item=>{
								if(item.whether!='是'&&!temp){
									delete item.persons
									delete item.companys
								}
								delete item.quest
								return item
							}))
							console.log(JSON.parse(form.form))
							form.files = this.fileList.join(',')
							form.status = temp?'暂存':'已申报'
							this.$http.post('/api/ts/v0.1/interest/save',form)
							.then(res=>{
									this.closeLoading()
									console.log(res)
									if (res.data == 1) {
											// this.Dialog.confirm({
											// 		title:this.$t('tx'),
											// 		message:temp?this.$en('暂存成功，是否关闭页面？'):this.$en('申报提交成功，是否关闭页面？')
											// }).then(() => {
											// 		this.$router.go(-1)
											// }).catch(() => {
											// 		this.checked = false
											// })
											
										if(!temp){
											this.checked = false
										}
										this.Dialog.alert({
											title:this.$en('提醒'),
											message:temp?this.$en('暂存成功'):this.$en('申报提交成功')
										}).then(()=>{
											if(!temp){
												this.$router.push({
														name: "index",
												});
											}
										})
										// this.Dialog.alert({
										// 	title:this.$en('提醒'),
										// 	message:temp?this.$en('暂存成功'):this.$en('申报提交成功')
										// })
											
											// this.form = {}
									} else{
											// this.$message.error('您已经提交过了') 
											this.Dialog.confirm({
													title:this.$t('tx'),
													message:this.$en('操作失败，请联系管理员 田辉阳 (tianhy16)')+'err1:'+JSON.stringify(res)
											}).then(() => {
													this.$router.go(-1)
											}).catch(() => {
													this.checked = false
											})
									}
									this.loading = false
							})
							.catch((err)=>{
									this.closeLoading()
									this.loading = false
									// this.$message.error('操作失败')
									this.Dialog.alert({
											title:this.$en('警告'),
											message:this.$en('操作失败，请联系管理员 田辉阳 (tianhy16)')+'err2:'+JSON.stringify(err)
									})
									this.checked = true
									this.disStatus = false
							})
					}).catch(()=>{

					})
        },
				isValidID(id) {
					const regex = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
					return regex.test(id);
				},
				isValidPhone(value){
					if(!value){
						return false
					}
					const regex = /^[\d+-]+$/
					return regex.test(value)
				},
        ratioInput(value){
					console.log(value)
					let v = value
					if(v){
						v = v.replace('-','')
						if(v.endsWith('.')){
							v = parseFloat(value)+'.'
						}else{
							v = parseInt(parseFloat(value)*10000)/10000
						}
						if(v>100){
							v = 100
						}
						// if (value.includes('.')){
						// 	this.$message.error('经济影响只能设置为正整数')
						// 	this.form.valueImpact = Number(this.form.valueImpact).toFixed(0)
						// }
						// if (this.form.valueImpact.includes('-')){
						// 	this.$message.error('经济影响只能设置为正整数')
						// 	this.form.valueImpact = this.form.valueImpact.replace('-','')
						// }
					}
					return v
        }
    }
}
</script>
<style scoped lang="less">
    .interest_container{
        width: 100%;
        height:100%;
				background-color: #f2f2f2;
				overflow: auto;
    }
    .interest_body{
        width: 100%;
        left: 0;
        top: 0;
        bottom: 0;
        background-color: white;
				overflow-y: auto;
				padding-bottom: 20px;
    }
    .interest_body_content{
        width: 100%;
        height: auto;
        padding: 20px;
        box-sizing: border-box;
        text-align: left;
        font-size: 16px;
        line-height: 24px;
    }
    .interest_bottom_btn{
        width: 120px;
        height: 40px;
        background-color: #0169ff;
        border-radius: 4px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 30px;
        font-size: 16px;
        color: white;
        line-height: 40px;
        text-align: center;
    }
    .page_bottom_btn{
        width: 120px;
        height: 40px;
        background-color: #0169ff;
        border-radius: 4px;
        left: 50%;
        bottom: 85px;
        margin-left: -60px;
        font-size: 16px;
        color: white;
        line-height: 40px;
        text-align: center;
    }
    .interest_show_content{
        width: 100%;
				height:100%;
				overflow: auto;
        background-image: linear-gradient(180deg,#dee6fc 10%,  #f7f8fd 100%);
    }
    .show_content_box{
			// margin-top:60px;
			padding-bottom: 30px;
			margin-left:3%;
			width: 94%;
			background-color: white;
    }
    .content_box_head{
        width: 100%;
        min-height: 40px;
        border-bottom: 1px solid #f5f5f5;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .box_head_line{
        width: 3px;
        height: 14px;
        background-color: rgba(183, 159, 134, 1);
        margin-left: 20px;
    }
    .box_head_title{
        flex: 1;
        min-height: 40px;
        margin-left: 10px;
        font-size: 18px;
        color: #333;
        font-weight: 700;
        line-height: 40px;
        text-align: left;
    }
    .box_head_num{
        width: 40px;
        height: 40px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: #666;
        letter-spacing: 3px;
				margin-right: 10px;
				margin-left:10px;
    }
    .content_box_middle{
        width: 100%;
        height: auto;
        padding: 20px;
        box-sizing: border-box;
        font-size: 16px;
        color: #333;
        text-align: left;
        line-height: 24px;
    }
    .content_box_select{
        width: 100%;
        height: auto;
        padding: 20px;
        box-sizing: border-box;
    }
    .select_item_block{
        width: 100%;
        height: 36px;
        background-color: #e7f8ea;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .select_default_block{
        width: 100%;
        height: 36px;
        border: 1px solid rgba(215, 215, 215, 1);
        border-radius: 4px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .check_select_block{
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: #38a65a;
        margin-left: 15px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .check_default_block{
        width: 18px;
        height: 18px;
        border: 1px solid #c5c5c5;
        border-radius: 50%;
        box-sizing: border-box;
        margin-left: 15px;
    }
    .box_select_text{
        display: block;
        font-size: 16px;
        color: #333;
        margin-left: 10px;
    }
    .content_box_areatext{
        width: 100%;
        height: auto;
        padding: 30px 20px;
        box-sizing: border-box;
        margin-bottom: 20px;
    }
    .box_area_title{
        display: block;
        font-size: 16px;
        color: #333;
        text-align: left;
		}
		.change_btn_flex{
        width: 64px;
        height: 64px;
        background: radial-gradient(rgb(155, 205, 238, .6) 0,rgb(233, 242, 251, .6) 100%);
        border-radius: 50%;
				position: fixed;
        flex-direction: row;
        justify-content: center;
				align-items: center;
				display: flex;
		}
		.change_btn{
        width: 64px;
        height: 64px;
        background: radial-gradient(rgb(155, 205, 238, .6) 0,rgb(233, 242, 251, .6) 100%);
        border-radius: 50%;
				display:inline-block;
				position: relative;
		}
    .left_change_btn{
        left: 10px;
				// bottom: 50px;
				float: left;
    }
    .right_change_btn{
        right: 10px;
				// bottom: 50px;
				float: right;
		}
		.change_tbn_i{
			position:absolute;
			top:50%;
			left:50%;
			transform:translate(-50%,-50%)
		}
    .interest_show_list{
        width: 100%;
        left: 0;
        top: 0;
        bottom: 0;
    }
    .show_list_block{
        width: 100%;
        left: 0;
        top: 0;
        bottom: 70px;
        background-color: white;
        overflow-y: auto;
    }
    .show_list_bottom{
        width: 100%;
        height: 70px;
        background-color: white;
        left: 0;
        bottom: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
    }
    .list_bottom_btn{
        width: 120px;
        height: 40px;
        background-color: #0169ff;
        border-radius: 4px;
        font-size: 16px;
        color: white;
        line-height: 40px;
        text-align: center;
    }
    .list_limit_btn{
        width: 120px;
        height: 40px;
        background-color: #ccc;
        border-radius: 4px;
        font-size: 16px;
        color: #eee;
        line-height: 40px;
        text-align: center;
    }
    .show_list_item{
        width: 100%;
        height: auto;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
    }
    .show_list_check{
        width: 100%;
        height: auto;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 16px;
        color: #333;
        text-align: left;
		.show_list_check_text{
			padding-left:28px;
			font-size: 15px;
			font-family: 宋体;
		}
    }
    .list_item_head{
        width: 100%;
        height: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .item_head_line{
        width: 3px;
        height: 14px;
        background-color: rgba(183, 159, 134, 1);
    }
    .item_head_title{
        display: block;
				font-size: 18px;
				font-weight: 700;
        color: #333;
        font-weight: 700;
        line-height: 40px;
        text-align: left;
        margin-left: 5px;
    }
    .list_item_quest{
        width: 100%;
        height: auto;
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 16px;
        color: #333;
        text-align: left;
        line-height: 24px;
    }
    .list_item_check{
        width: 100%;
        height: 36px;
        background-color: #e7f8ea;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .list_item_desc{
        width: 100%;
        height: auto;
        background-color: #f2f2f2;
        margin-top: 10px;
        margin-bottom: 10px;
        padding: 10px;
        box-sizing: border-box;
        font-size: 16px;
        color: #333;
        text-align: left;
        line-height: 24px;
		}
		/deep/ .van-field__control{
			text-align:right;
		}
		/deep/ .parent_card .van-cell-group .van-cell{
			background-color:unset;
		}
		/deep/ .van-cell-group{
			background-color: rgba(237,238,240,0.6);
			// background-color: red;
			border-radius: 10px;
			padding-bottom: 1px;
			margin-bottom:10px;
		}
		.van-cell__title{
			text-align: left;
			width:40%
		}
		/deep/ .title_card .van-cell__title{
			font-size: 18px;
			flex:unset;
			-webkit-box-flex:unset;
			-webkit-flex:unset;
		}
		/deep/ .title_card_son .van-cell__title{
			font-size: 16px;
			flex:unset;
			-webkit-box-flex:unset;
			-webkit-flex:unset;
		}
		/deep/ .content_box_areatext .title_card .van-cell__title{
			width: calc( 100% - 80px );
		}
		/deep/ .content_box_areatext .title_card_son .van-cell__title{
			width: calc( 100% - 80px );
		}
		/deep/ .show_list_block .title_card .van-cell__title{
			width: calc( 100% - 170px );
		}
		/deep/ .show_list_block .title_card_son .van-cell__title{
			width: calc( 100% - 170px );
		}

		.son_card{
			border-radius: 5px;
			margin:10px;
			background-color:white;
		}
		.van-cell-group section:first-of-type{
			margin-top: 0px;
		}
		.parent_card_pt20 .van-cell-group{
			padding-top: 10px;
		}
		// .van-cell-group:has(section:first-of-type){
		// 	padding-top:20px;
		// }

		/deep/ .interest_van_icon{
			font-weight: 800;
			font-size: 16px;
			margin-left: 20px;
		}

		/deep/ .van-field .van-field__label{
			font-size:16px;
			color:#333333;
			// font-weight: 700;
		}
		/deep/ .van-icon-arrow{
			line-height: 24px !important;
		}
		.title_card .van-cell__title{
			font-weight: 700;
		}
		.title_card_son .van-cell__title{
			font-weight: 700;
		}
		.title_card::before{
			content: ' ';
			width: 3px;
			height: 14px;
			background-color: #b79f86;
			margin: 5px 5px 5px 0px;
		}
		.title_son_card .van-cell__title{
			font-weight: 700;
		}
		.title_son_card::before{
			content: ' ';
			width: 3px;
			height: 14px;
			background-color: #b79f8680;
			margin: 5px 5px 5px 0px;
		}
		/deep/ .last_page_list .title_card .van-cell__title{
			font-size: 16px;
		}
		.last_page_count{
			font-size: 16px;
		}
		/deep/ .color_red{
			// color:red;
		}
		/deep/ .font_bold{
			font-weight: 800;
		}

		::v-deep .van-radio__label{
			font-size: 16px;
		}
		::v-deep .van-field__control{
			font-size: 16px;
		}
		::v-deep .van-button{
			font-size: 16px;
		}

    /* PC端响应式样式 */
    @media (min-width: 769px) {
        .interest_container{
            width: 100%;
            height: 100%;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 40px 20px;
            box-sizing: border-box;
        }
        .interest_body{
            width: 100%;
            background-color: #fff;
            padding: 6px 20px;
            margin-bottom: 10px;
        }
        .interest_head_block{
            width: 100%;
            padding: 6px 20px;
            background: #fff;
            position: relative;
            margin-bottom: 10px;
            border: none;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 4px;
                bottom: 4px;
                width: 4px;
                background-color: #027cfb;
                border-radius: 0 6px 6px 0;
            }
        }
        .head_block_title{
            margin: 0;
            font-size: 18px;
            font-weight: 600;
            color: #333;
        }
        .interest_body_content{
            font-size: 18px;
            line-height: 28px;
            border-top: 1px solid #999;
            padding-top: 20px;
        }
        .interest_bottom_btn{
            width: 180px;
            height: 44px;
            line-height: 44px;
            font-size: 18px;
            cursor: pointer;
            transition: background-color 0.2s;
            &:hover{
                background-color: #0055cc;
            }
        }
        .interest_show_content{
            width: 100%;
            height: 100%;
            background-image: none;
            background-color: #fff;
            border-top: 1px solid #999;
            overflow-y: auto;
            font-size: 18px;
            position: relative;
        }
        .pc_save_btn{
            position: fixed;
            bottom: 05%;
			right: 50%;
            height: 40px;
            width: 120px;
            background: rgb(230, 240, 255);
            color: #0283ef;
            font-size: 18px;
            z-index: 10;
            cursor: pointer;
        }
        .show_content_box{
            width: auto;
            margin-left: 0;
            padding: 20px 30px;
        }
        .content_box_head{
            min-height: auto;
            padding: 10px 0;
            border-bottom: none;
        }
        .box_head_line{
            width: 4px;
            height: 40px;
            background-color: #027cfb;
            margin-left: 0;
            border-radius: 0 3px 3px 0;
        }
        .box_head_title{
            font-size: 20px;
            line-height: 40px;
        }
        .box_head_num{
            font-size: 18px;
        }
        .content_box_middle{
            font-size: 18px;
            line-height: 28px;
            padding: 15px 20px;
        }
        .content_box_select{
            padding: 15px 20px;
        }
        .select_item_block{
            height: auto;
            min-height: 36px;
            padding: 4px 0;
        }
        .select_default_block{
            height: auto;
            min-height: 36px;
            padding: 4px 0;
        }
        .box_select_text{
            font-size: 18px;
        }
        .content_box_areatext{
            padding: 15px 20px;
        }
        .box_area_title{
            font-size: 18px;
        }
        .change_btn{
            width: 54px;
            height: 54px;
        }
        .interest_show_list{
            width: 100%;
            height: 100%;
        }
        .show_list_block{
            width: 100%;
            height: calc(100% - 70px);
            font-size: 18px;
            overflow-y: auto;
        }
        .show_list_bottom{
            width: 100%;
            height: 70px;
            position: relative;
        }
        .list_bottom_btn{
            width: 180px;
            height: 44px;
            line-height: 44px;
            font-size: 18px;
            cursor: pointer;
            transition: background-color 0.2s;
            &:hover{
                background-color: #0055cc;
            }
        }
        .list_limit_btn{
            width: 180px;
            height: 44px;
            line-height: 44px;
            font-size: 18px;
        }
        .show_list_item{
            padding-left: 30px;
            padding-right: 30px;
        }
        .list_item_head{
            height: auto;
            padding: 10px 0;
        }
        .item_head_line{
            width: 4px;
            height: 32px;
            background-color: #027cfb;
            border-radius: 0 3px 3px 0;
        }
        .item_head_title{
            font-size: 18px;
			padding-left: 10px;
        }
        .list_item_quest{
            font-size: 18px;
            line-height: 28px;
        }
        .list_item_check{
            height: auto;
            min-height: 36px;
        }
        .list_item_desc{
            font-size: 18px;
            line-height: 28px;
        }
        .show_list_check{
            font-size: 18px;
			.show_list_check_text{
            	font-size: 18px;
			}
        }
        /deep/ .van-field .van-field__label{
            font-size: 18px;
			font-weight: 700;
            width: 230px !important;
            flex: none !important;
            -webkit-box-flex: 0 !important;
            -webkit-flex: none !important;
        }
        /deep/ .van-field__control{
            font-size: 18px;
            text-align: left;
        }
        /deep/ .el-textarea__inner{
            font-size: 18px !important;
            text-align: left;
        }
        ::v-deep .van-radio__label{
            font-size: 18px;
        }
        /deep/ .content_box_areatext .van-cell .van-cell__title{
            font-size: 18px;
            font-weight: 700;
            width: 230px;
            flex: none;
            -webkit-box-flex: 0;
            -webkit-flex: none;
        }
        /deep/ .content_box_areatext .van-cell .van-radio-group{
            justify-content: flex-start;
        }
        ::v-deep .van-button{
            font-size: 18px;
        }
        /deep/ .title_card .van-cell__title{
            font-size: 18px;
        }
        /deep/ .title_card_son .van-cell__title{
            font-size: 18px;
        }
        /deep/ .interest_van_icon{
            font-size: 18px;
        }
        /deep/ .last_page_list .title_card .van-cell__title{
            font-size: 18px;
        }
        .last_page_count{
            font-size: 18px;
        }
        .picker_popup_mobile{
            display: none !important;
        }
        .pc_picker_list{
            max-height: 400px;
            overflow-y: auto;
        }
        .pc_picker_item{
            padding: 12px 20px;
            font-size: 18px;
            color: #333;
            cursor: pointer;
            transition: background-color 0.15s;
            border-radius: 4px;
            &:hover{
                background-color: #f5f7fa;
            }
        }
        .pc_picker_item_active{
            color: #027cfb;
            font-weight: 600;
            background-color: #ecf5ff;
        }
    }
</style>
<style>
	.van-dialog .van-dialog__header{
		font-size:18px;
	}
	.van-dialog .van-dialog__content .van-dialog__message{
		font-size:16px;
	}
	.van-dialog .van-dialog__footer{
		font-size:16px;
	}
	.van-popup .van-picker__toolbar .van-picker__cancel{
		font-size:16px;
	}
	.van-popup .van-picker__toolbar .van-picker__confirm{
		font-size:16px;
	}
	.pc_picker_dialog .el-dialog__header{
		border-bottom: 1px solid #ebeef5;
		padding-bottom: 16px;
	}
	.pc_picker_dialog .el-dialog__title{
		font-size: 18px;
		font-weight: 600;
	}
	.pc_picker_dialog .el-dialog__body{
		padding-top: 10px;
		padding-bottom: 10px;
	}
	@media (min-width: 769px) {
		.picker_popup_mobile{
			display: none !important;
		}
	}
</style>